(function() {
  'use strict';

  var dependencies = [
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ngRoute',
    'ngMaterial',
    'ngRaven',
    'base64',
    'validation.match',
    'angular-clipboard',
    'angularMoment',
    'thb.config',
    'md.data.table',
    'angulartics',
    'infinite-scroll',
    'ng.deviceDetector',
    'ngStorage'
  ];

  try {
    angular.module('angulartics.google.analytics'); // this throws if GA script is not loaded
    dependencies.push('angulartics.google.analytics');
  } catch (e) {
    console.error('GA is not available: ' + e);  // eslint-disable-line
  }

  angular
    .module('thb', dependencies).controller('MainController', MainController);

  /** @ngInject */
  function MainController(ThemingService, $mdMedia, $location) {
    var vm = this;
    vm.service = ThemingService;
    vm.shouldHide = shouldHide;

    function shouldHide() {
      var path = $location.path();
      return $mdMedia('xs') && (path === '/' || path === '' || path === '/manual');
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('TriageCompletedController', TriageCompletedController);

  /** @ngInject */
  function TriageCompletedController(LocationService, AccountLog, mdPanelRef, $location) {
    var vm = this;
    vm.undo = undoTriage;
    vm.copy = copyLocation;
    vm.history = goToHistory;


    function undoTriage() {
      var solution = vm.selectedSolution;
      return AccountLog.delete({
        id: solution.id
      }).$promise.then(function() {
        vm.selectedSolution = undefined;
        vm.onUndo();
      }, vm.onError)
        .then(close);

    }

    function copyLocation() {
      LocationService.copyBreadCrumbs(' - ' + vm.selectedSolution.name);
      close();
    }

    function goToHistory() {
      $location.url('/account/logs');
      close();
    }

    function close() {
      mdPanelRef.close();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('thb')
    .directive('codes', CodesDirective);

  /** @ngInject */
  function CodesDirective() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/thb/symptom/codes/codes.html',
      controller: CodesController,
      controllerAs: '$ctrl',
      bindToController: true,
      scope: {
        codes: '<',
        name: '<'
      }
    };

    return directive;

    /** @ngInject */
    function CodesController() {
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(
    $mdDialog,
    $base64,
    $location,
    $http,
    THB_URL) {

    var vm = this;
    vm.submit = submit;

    var query = $location.search();
    if (query.data) {
      var b64 = query.data;
      var length =  b64.length % 4;
      if (length > 0) {
        b64 += _.repeat('=', 4 - length);
      }
      vm.params = _.reduce($base64.decode(b64).split('&'), function(params, keyVal) {
        var param = keyVal.split('=');
        params[param[0]] = param[1];
        return params;
      }, {});
      vm.hasData = !!vm.params.uuid;
    }

    function submit(event) {
      vm.submitted = true;
      $http({
        method: 'POST',
        url: THB_URL + '/passwordreset',
        data: {
          username: vm.params.username, // TODO Remove me
          uuid: vm.params.uuid,
          password: vm.hash
        }
      }).then(success.bind(null, event), fail.bind(null, event));
    }

    function success(event) {
      vm.submitted = false;
      var content = 'Ditt lösenord har uppdaterats, och du kan nu använda det '+
      'för att logga in.';
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Lösenord uppdaterat')
        .textContent(content)
        .ariaLabel('Lösenord uppdaterats dialog')
        .ok('OK')
        .targetEvent(event);
      $mdDialog.show(dialog).then(function() {
        $location.url('/login');
      });
    }

    function fail(event) {
      vm.submitted = false;
      var content = 'Något gick fel när ditt lösenord skulle sparas. ' +
      'Försök igen senare eller kontakta oss.';
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Fel!')
        .textContent(content)
        .ariaLabel('Feldialog')
        .ok('OK')
        .targetEvent(event);
      $mdDialog.show(dialog);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController($mdDialog, $http, THB_URL, $location) {
    var vm = this;

    vm.submit = submit;

    function submit(event) {
      vm.submitted = true;
      $http({
        method: 'GET',
        url: THB_URL + '/passwordreset',
        params: {username: vm.username, host: $location.host()}
      }).then(success.bind(null, event), fail.bind(null, event));
    }

    function success(event) {
      vm.submitted = false;
      var content = 'Ett mail kommer att skickas till ' + vm.username +
      ' om adressen finns registrerad. Om du inte fått ett mail inom fem minuter' +
      ' kan detta bero på att du använt en annan e-postadress vid registrering.';
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Återställning')
        .textContent(content)
        .ariaLabel('Återställ lösenord dialog')
        .ok('OK')
        .targetEvent(event);
      $mdDialog.show(dialog);
    }

    function fail(event) {
      vm.submitted = false;
      var content = 'Något gick fel med din återställning. Försök igen ' +
      'senare eller kontakta oss.';
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Fel!')
        .textContent(content)
        .ariaLabel('Fel vid återställning')
        .ok('OK')
        .targetEvent(event);
      $mdDialog.show(dialog);
    }

  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('Symptom', SymptomResource);

  /** @ngInject */
  function SymptomResource($resource, THB_URL) {

    var resource = $resource(THB_URL + '/symptom/:id/', {
      id: '@id'
    }, {
      update: {
        method: 'PUT'
      }
    });

    return resource;
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('SymptomController', SymptomController);

  /** @ngInject */
  function SymptomController($scope, $document, $location, $mdPanel,
                             $mdToast, symptom, AccountLog, $mdMedia, $analytics, $sce) {
    var vm = this;
    _.merge(vm, symptom);
    vm.$sce = $sce;
    var query = $location.search();
    if (!_.isEmpty(query)) {
      if (query.solution && query.date && query.id) {
        var id = Number(query.id);
        setSolution({
          id: id,
          date: query.date,
          solutionId: Number(query.solution),
          undoable: withinWeek(query.date)
        });
      }
    }

    vm.codeTypes = [
      { name: 'ICD', codes: vm.icd },
      { name: 'KSH97', codes: vm.ksh97 }
    ];

    // hide toast when navigating away from the page
    $scope.$on('$destroy', $mdToast.hide);

    vm.cardClicked = cardClicked;
    vm.solutionClicked = solutionClicked;
    vm.isSelected = isSelected;

    function solutionClicked() {
      if (vm.selectedSolution) {
        return showPanel(vm.selectedSolution);
      }
    }

    function cardClicked(solution) {
      if (!vm.selectedSolution) {
        triage(solution);
      }
    }

    function triage(solution) {
      var log = {
        date: moment().toDate(),
        levelId: solution.id,
        version: 'tonttu'
      };
      AccountLog.save(log)
        .$promise
        .then(triageSuccess, triageError);
    }

    function isSelected(solution) {
      return vm.selectedSolution && solution.id === vm.selectedSolution.solutionId;
    }

    function withinWeek(date) {
      return moment().diff(moment(date), 'days') <= 7;
    }

    function triageSuccess(solution) {
      solution.undoable = true;
      setSolution(solution);
      showPanel(solution);
      $analytics.eventTrack('triageSuccess');
    }

    function setSolution(solution) {
      vm.selectedSolution = solution;
      if (solution) {
        vm.selectedSolution.name = _.find(symptom.solutions, { id: solution.solutionId }).name;
      }
    }

    function showPanel(solution) {
      var position = $mdPanel.newPanelPosition()
        .relativeTo('#solution-' + solution.solutionId)
        .addPanelPosition($mdPanel.xPosition.OFFSET_END, $mdPanel.yPosition.CENTER);
      if ($mdMedia('xs')) {
        position.withOffsetY('8px');
      } else {
        position.withOffsetX('16px');
      }
      $mdPanel.open({
        templateUrl: 'app/thb/symptom/triageCompleted/triageCompleted.html',
        controller: 'TriageCompletedController',
        controllerAs: '$ctrl',
        position: position,
        locals: {
          selectedSolution: vm.selectedSolution,
          onUndo: setSolution.bind(null),
          onError: triageError
        },
        bindToController: true,
        parent: angular.element($document[0].querySelector('.content')),
        clickOutsideToClose: true,
        escapeToClose: true
      });
    }

    function triageError() {
      showToast('Ett fel uppstod. Var god försök igen.');
    }

    function showToast(msg, delay) {
      if (!delay && delay !== 0) {
        delay = 3000;
      }
      $mdToast.hide().then(
        $mdToast.show.bind(null,
          $mdToast.simple()
            .textContent(msg)
            .position('top right')
            .hideDelay(delay)
            .parent(angular.element($document[0].querySelector('.content')))
        )
      );

    }
  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('Subcategory', SubcategoryResource);

  /** @ngInject */
  function SubcategoryResource($resource, THB_URL) {

    var resource = $resource(THB_URL + '/subcategory/:id/', {
      id: '@id'
    }, {
      get:  {
        method:'GET'
      },
      update: {
        method: 'PUT'
      }
    });

    return resource;
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .controller('SubCategoryController', SubCategoryController);

  /** @ngInject */
  function SubCategoryController(subcategory, $location) {
    var vm = this;
    _.merge(vm, subcategory);
    vm.prefix = /^\/preview-edits\//.test($location.path()) ? '/preview-edits' : '';
  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('News', NewsResource);

  /** @ngInject */
  function NewsResource($resource, THB_URL) {

    var resource = $resource(THB_URL + '/news/:id/', {
      id: '@id'
    }, {
      update: {
        method: 'PUT'
      }
    });

    return resource;
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .controller('NewsController', NewsController);

    /** @ngInject */
    function NewsController(news, $sce, $mdMedia, $location) {
      var vm = this;
      vm.$sce = $sce;
      vm.news = news;
      vm.shouldHide = shouldHide;

      function shouldHide() {
        return $mdMedia('xs') && ($location.path() !== '/news')
      }
    }


})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('Manual', ManualResource);

  /** @ngInject */
  function ManualResource($resource, THB_URL) {

    var resource = $resource(THB_URL + '/manual/:id/', {
      id: '@id'
    }, {
      query: {
        method: 'GET',
        isArray: true,
        cache: true
      },
      update: {
        method: 'PUT'
      }
    });

    return resource;
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .controller('ManualController', ManualController);

    /** @ngInject */
    function ManualController(manualItem, THB_URL, $http, $sce, $mdMedia) {
      var vm = this;
      vm.$mdMedia = $mdMedia;

      if (manualItem) {
        _.merge(vm, manualItem);
        if (manualItem.link) {
          vm.pdfUrl = 'https://tonttu.se/db/resources/' + manualItem.link;
          if (navigator.userAgent.match(/.NET/g)) { // IE 11+
            vm.IE11 = true;
          } else {
            $http({
              url: THB_URL + '/resource/' + manualItem.link,
              method: 'GET',
              responseType: 'arraybuffer'
            }).then(function (result) {
              var pdf = new Blob([result.data], {type: 'application/pdf'});
              vm.pdf = $sce.trustAsResourceUrl(URL.createObjectURL(pdf));
            });
          }
        }
      }

    }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('MainSymptom', MainSymptomResource);

  /** @ngInject */
  function MainSymptomResource($resource, THB_URL) {

    var resource = $resource(THB_URL + '/main-symptom/:id/', {
      id: '@id'
    }, {
      update: {
        method: 'PUT'
      }
    });

    return resource;
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .controller('MainSymptomController', MainSymptomController);

  /** @ngInject */
  function MainSymptomController(mainSymptom, $location) {
    var vm = this;
    _.merge(vm, mainSymptom);
    vm.prefix = /^\/preview-edits\//.test($location.path()) ? '/preview-edits' : '';
  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('Category', CategoryResource);

  /** @ngInject */
  function CategoryResource($resource, THB_URL) {

    var resource = $resource(THB_URL + '/category/:id/', {
      id: '@id'
    }, {
      query: {
        method: 'GET',
        isArray: true,
        cache: true
      },
      update: {
        method: 'PUT'
      }
    });

    return resource;
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .controller('CategoryController', CategoryController);

  /** @ngInject */
  function CategoryController(category, $location) {
    var vm = this;
    _.merge(vm, category);
    vm.prefix = /^\/preview-edits\//.test($location.path()) ? '/preview-edits' : '';
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('RegistrationController', RegistrationController);

  /** @ngInject */
  function RegistrationController($mdDialog, User, $location, $analytics) {
    var vm = this;

    vm.submit = submit;

    function submit(event) {
      if (vm.isStudent) {
        vm.user.accountType = 'student';
      }
      vm.submitted = true;
      User.save(vm.user).$promise.then(success.bind(null, event), fail.bind(null, event));
    }

    function success(event) {
      vm.submitted = false;
      var content = 'Tack för din anmälan. Du kommer få ett mail när din anmälan ' +
        'har bearbetats.';
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Tack!')
        .textContent(content)
        .ariaLabel('Tack')
        .ok('OK')
        .targetEvent(event);
      $mdDialog.show(dialog).then(function() {
        $location.url('/');
      });
      $analytics.eventTrack('registrationSuccess');
    }

    function fail(event, response) {
      vm.submitted = false;
      var dialog;
      // duplicate email adresses
      if (response.status === 409) {
        // account is active
        if (response.data && response.data.active) {
          dialog = $mdDialog.confirm()
            .clickOutsideToClose(true)
            .title('Fel!')
            .ariaLabel('Fel')
            .targetEvent(event)
            .ok('Glömt lösenord')
            .cancel('Stäng')
            .textContent('Det finns redan ett konto med den här e-postadressen. Har du glömt ditt lösenord?');

          $mdDialog.show(dialog).then(function() {
            $location.url('/forgot-password');
          });
        } else {
          // account inactive
          var text = 'Ett konto med denna e-postadressen finns redan, '
            + 'men det inväntar godkännande från oss. '
            + 'Du kommer få ett mail när ditt konto blivit godkänt.';
          alert(event, text);
        }
      } else {
        // Unknown error
        var msg = 'Något gick fel med din anmälan. '
          + 'Försök igen senare eller kontakta oss.';
        alert(event, msg);
      }
    }

    function alert(event, message) {
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Ett fel uppstod!')
        .ariaLabel('Fel')
        .targetEvent(event)
        .textContent(message)
        .ok('OK');
      $mdDialog.show(dialog);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($location, AuthenticationService, $base64, $mdMedia, $log) {
    var vm = this;

    vm.loginError = false;
    vm.login = login;

    function login() {
      AuthenticationService
      .login(vm.email, vm.password)
      .then(function () {
        var loc = $location.search();
        var url;
        try {
          url = decodeURI($base64.decode(loc.redirectedFrom));
        } catch(err) {
          $log.info(err);
        }
        if (loc && !_.isEmpty(loc) && !($mdMedia('xs') && url && /^\/category\/\d+$/.test(url))) {
          $location.url(url);
        } else {
          $location.url('/');
        }
      },
      function (res) {
        if (res.status === 401) {
          vm.incorrect = true;
        } else if (res.status === 402) {
          if (res.data && res.data.accountType === 'pending') {
            vm.pendingAccount = true;
          } else {
            vm.inactiveAccount = true;
          }
        } else {
          vm.otherError = true;
        }
      });
    }
  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('ThemingService', ThemingService);

  /** @ngInject */
  function ThemingService() {
    var service = {
      theme: 'default',
      setTheme: setTheme
    };
    return service;

    function setTheme(color) {
      service.theme = color.toLowerCase().replace('#', '');
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .factory('ThbLoaderService', ThbLoaderService);

  /** @ngInject */
  function ThbLoaderService(LinkParserService, BreadCrumbsService, ThemingService) {
    var service = {
      load: load
    };
    return service;


    function load(resourceFunction, id) {
      var params = { id: id };
      // if (/^\/preview-edits\//.test($location.path())) {
      params.version = 'tonttu';
      // }
      var promise = resourceFunction(params).$promise;
      promise.then(success);
      return promise;
    }

    function success(data) {
      if (data.obs)
        data.obs = LinkParserService.parse(data.obs);
      if (data.breadCrumbs)
        BreadCrumbsService.crumble(data.breadCrumbs);
      if (data.colour)
        ThemingService.setTheme(data.colour);
      if (data.solutions) {
        _.each(data.solutions, function(solution) {
          solution.obs = LinkParserService.parse(solution.obs);
        });
      }
      return data;
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .directive('thbListItem', ThbListItem);

    /** @ngInject */
    function ThbListItem() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/thbListItem/thbListItem.html',
        controller: ThbListItemController,
        controllerAs: '$ctrl',
        bindToController: true,
        transclude: true,
        scope: {
          url: '<',
          click: '&',
          borderColour: '<'
        }
      }

      return directive;

      /** @ngInject */
      function ThbListItemController() {
        // var vm = this;
        // vm.getItemUrl = getItemUrl;
        //
        // function getItemUrl(item) {
        //   // cache value
        //   if (item._url) {
        //     return item._url;
        //   }
        //   var url = '#/';
        //   if (vm.urlPrefix) {
        //     url += kebab(vm.urlPrefix) + '/';
        //   }
        //   if (vm.itemUrlProperties) {
        //     var urlParts = _.split(vm.itemUrlProperties, ',');
        //     urlParts = _.map(urlParts, function(property) {
        //       var val = kebab(item[property]);
        //       return val ? val + '/': '';
        //     });
        //     url += urlParts.join('');
        //   }
        //   item._url = _.trim(url, '/');
        // }
        //
        // function kebab(str) {
        //   return vm.kebab ? _.kebabCase(str): str;
        // }
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('thb')
    .directive('selectableText', function($window, $timeout) {
      var i = 0;
      // var hasSelection = false;
      return {
        restrict: 'A',
        priority: 1,
        compile: function(tElem, tAttrs) {
          var fn = '$$clickOnNoSelect' + i++,
            _ngClick = tAttrs.ngClick;

          tAttrs.ngClick = fn + '($event)';

          return function(scope) {
            var lastAnchorOffset, lastFocusOffset, timer;

            scope[fn] = function(event) {
              var selection = $window.getSelection(),
                anchorOffset = selection.anchorOffset,
                focusOffset = selection.focusOffset;

              if (focusOffset - anchorOffset !== 0) {
                if (!(lastAnchorOffset === anchorOffset && lastFocusOffset === focusOffset)) {
                  lastAnchorOffset = anchorOffset;
                  lastFocusOffset = focusOffset;
                  if (timer) {
                    $timeout.cancel(timer);
                    timer = null;
                  }
                  // hasSelection = true;
                  return;
                }
              }
              lastAnchorOffset = null;
              lastFocusOffset = null;
              // if (hasSelection) {
              //   hasSelection = false;
              //   return;
              // }

              // delay invoking click so as to watch for user double-clicking
              // to select words
              timer = $timeout(function() {
                scope.$eval(_ngClick, { $event: event });
                timer = null;
              }, 250);
            };
          };
        }
      };
    });
})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('Search', SearchResource);

  /** @ngInject */
  function SearchResource($resource, THB_URL) {

    var resource = $resource(THB_URL + '/search', {}, {
      query: {
        method: 'GET',
        isArray: true,
        cancellable: true
      },
      cache: true
    });
    return resource;
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .directive('search', Search);

    /** @ngInject */
    function Search($location) {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/search/search.html',
        controller: SearchController,
        controllerAs: 's',
        bindToController: true
      }

      return directive;

      /** @ngInject */
      function SearchController($scope, Search, LinkParserService, $mdSidenav) {
        var vm = this;
        vm.results = [];
        vm.search = search;
        vm.close = close;
        vm.parser = LinkParserService;
        vm.navigate = navigate;
        vm.tryClear = tryClear;
        vm.kebab = _.kebabCase;

        $scope.$watch(
            function() { return $mdSidenav('search').isOpen(); },
            function(open) {
                if (!open) {
                  clear();
                }
            }
        );

        function close() {
          $mdSidenav('search').close();
        }

        function tryClear(query) {
          if (!query || query === '') {
            clear();
          }
        }

        function clear() {
          vm.results.length = 0;
          vm.query = vm.selectedItem = undefined;
        }

        function navigate(place, id) {
          $location.url('/' + _.kebabCase(place) + '/' + id);
          close();
        }

        function search(value) {
          vm.noResult = false;
          if (vm.lastSearch) {
            vm.lastSearch.$cancelRequest();
          }
          vm.lastSearch = Search.query({query: value, version: 'tonttu'});
          return vm.lastSearch.$promise
          .then(highlightText.bind(null, value))
          .then(function(data) {
            // no results
            if (!data.length) {
              vm.noResult = true;
            }
            vm.results = data;
            return []; // return empty array to prevent default result list
          });
        }

        function highlightText(query, data) {
          var queries = _.reverse(_.sortBy(query.split(' '), 'length')); // divide query string into words
          var props = ['name', 'obs', 'navigation'] // some properties to iterate over
          _.forEach(queries, function(query) {
            var regex = new RegExp(query, "ig");
            _.forEach(data, function (object) {
              // highlight regular properties
              _.forEach(props, function(prop) {
                if (object[prop]) {
                  object[prop] = object[prop].replace(regex, '<span class="highlight">$&</span>');
                }
              });
              // highlight codes
              replaceCodes(regex, object, 'icd');
              replaceCodes(regex, object, 'ksh97');
            });
          })
          return data;
        }

        function replaceCodes(regex, object, property) {
          if (object[property]) {
            _.forEach(object[property], function(code) {
              code.codeText = code.codeText.replace(regex, '<span class="highlight">$&</span>');
            });
          }
        }

      }
    }
})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('NavBarService', NavBarService);

  /** @ngInject */
  function NavBarService() {
    var service = {
      showSearch: false
    };
    return service;

  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .directive('navbar', thbNavbar);

  /** @ngInject */
  function thbNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      controller: NavbarController,
      controllerAs: 'nav',
      bindToController: true,
      replace: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(ThemingService, $mdSidenav,
                              $mdMedia, $location,
                              AuthenticationService, NavBarService, LocationService) {
      var vm = this;
      vm.$mdMedia = $mdMedia;
      vm.$location = $location;
      vm.service = ThemingService;
      vm.auth = AuthenticationService;
      vm.navBarService = NavBarService;
      vm.openMainMenu = function() {
        $mdSidenav('main-menu').toggle();
      };
      vm.openSearch = function() {
        vm.closeMainMenu();
        $mdSidenav('search').toggle();
      };

      vm.closeMainMenu = function() {
        $mdSidenav('main-menu').close();
      };

      vm.breadCrumbsText = '';

      vm.isFrontPage = LocationService.isFrontPage;

      vm.copyBreadCrumbs = LocationService.copyBreadCrumbs;

    }
  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .directive('mdTooltip', MdTooltipDirective);

  function MdTooltipDirective() {  //create your overriding directive
    return{
      replace: true,
      template: '<span style="display:none"></span>',
      scope: {}, //create an isolated scope
      link: function(scope, element){
         element.remove();
         scope.$destroy();
      }
    }
  }

  angular
  .module('thb')
  .decorator('mdTooltipDirective', MdTooltipDecorator);

  /** ngInject */
  function MdTooltipDecorator($delegate, deviceDetector){

    var version = 0;
    var onMobile = deviceDetector.isMobile();//do your checking here

    if(onMobile) //here comes the switching
      version = 1;

    return [$delegate[version]];

  }
})();

(function() {
  'use strict';

  angular
    .module('thb')
    .directive('mainMenu', MainMenu);

  /** @ngInject */
  function MainMenu() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/mainMenu/mainMenu.html',
      controller: MainMenuController,
      controllerAs: 'mm',
      bindToController: true
    };
    return directive;

    /** @ngInject */
    function MainMenuController(AuthenticationService, $location, $mdSidenav) {
      var vm = this;
      vm.auth = AuthenticationService;
      vm.isAuthenticated = AuthenticationService.isAuthenticated;
      vm.navigateTo = function(location) {
        $location.url(location);
         $mdSidenav('main-menu').toggle();
      }

      vm.logout = function() {
        AuthenticationService.logout();
        $location.url('/');
        $mdSidenav('main-menu').toggle();
      }

      vm.mobileItems = [
        {
          title: 'Triagehandboken',
          url: '/',
          icon: 'title'
        },
        {
          title: 'Manual',
          url: '/manual',
          icon: 'book'
        },
        {
          title: 'Nyheter',
          url: '/news',
          icon: 'new_releases'
        },
        {
          title: 'Historik',
          url: '/account/logs',
          icon: 'history',
          authenticated: true
        }
      ]

      vm.readerItems = [
        {
          title: 'Triagehandboken',
          url: '/',
          icon: 'title'
        },
        {
          title: 'Manual',
          url: '/manual/1',
          icon: 'book'
        },
        {
          title: 'Historik',
          url: '/account/logs',
          icon: 'history'
        }
      ];

      vm.editorItems = [
        {
          title: 'Nya triagehandboken',
          url: '/preview-edits/',
          icon: 'lightbulb_outline'
        }
      ];

      vm.adminItems = [
        {
          title: 'Hantera användare',
          url: '/admin/users',
          icon: 'plus_one'
        }
      ];

      vm.generalItems = [
        {
          title: 'Kontoinställningar',
          url: '/account/settings',
          icon: 'settings'
        },
        {
          title: 'Lämna feedback',
          url: '/feedback',
          icon: 'feedback'
        }
      ];

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('thb')
    .factory('LocationService', LocationService);

  /** @ngInject */
  function LocationService($rootScope, $location, $mdMedia, BreadCrumbsService,
                           $mdToast, $mdDialog, $document, clipboard) {
    var currentPath;

    var service = {
      isTHB: isTHB,
      isFrontPage: isFrontPage,
      copyBreadCrumbs: copyBreadCrumbs
    };

    // If we navigate to the start page, we want to update the currentPath
    // so that breadcrumbs disappear instantly.
    $rootScope.$on('$routeChangeStart', function (ignore, nextRoute) {
      var regexp = nextRoute.regexp;
      if (regexp && regexp.test('/')) {
        currentPath = $location.path();
      }
    });
    $rootScope.$on('$routeChangeSuccess', function () {
      currentPath = $location.path();
    });

    return service;

    function isTHB() {
      var p = currentPath;
      return $mdMedia('xs')
        && (/\/category\//.test(p)
          || /\/subcategory\//.test(p)
          || /\/main-symptom\//.test(p)
          || /\/symptom\//.test(p)
          || /\/manual\/?\d+/.test(p)
          || /\/news\/?/.test(p)
        );
    }

    function isFrontPage() {
      return currentPath === '/' || currentPath === '';
    }


    /**
     * Add the current thb position to clipboard or show dialog.
     * @param extra extra string to add to location
     */
    function copyBreadCrumbs(extra) {
      extra = extra || '';
      var location = BreadCrumbsService.getCopyLocation() + extra;
      if (clipboard.supported) {
        clipboard.copyText(location);
        copySuccess();
        if (document.activeElement) {
          document.activeElement.blur();
        }
        // $("input").blur();
      } else {
        copyDialog(location);
      }
    }

    /**
     * Display a toast that explains that the position in THB was copied.
     */
    function copySuccess() {
      $mdToast.show(
        $mdToast.simple()
          .textContent('Din plats har kopierats.')
          .position('top right')
          .parent(angular.element($document[0].querySelector('.content')))
      );
    }

    /**
     * Display a dialog that allows the user to copy the location manually
     */
    function copyDialog(copyText) {
      var parentEl = $document.body;
      $mdDialog.show({
        parent: parentEl,
        bindToController: true,
        controllerAs: 'copy',
        templateUrl: 'app/components/navbar/copyTextDialog.tmpl.html',
        locals: {
          location: copyText
        },
        controller: DialogController
      });

      function DialogController($mdDialog, location) {
        var dialogVm = this;
        var isCtrlDown = false;
        var isCDown = false;

        dialogVm.location = location;

        // key up / down functions
        dialogVm.down = keyUpDown.bind(null, true);
        dialogVm.up = keyUpDown.bind(null, false);

        dialogVm.closeDialog = function () {
          $mdDialog.hide();
        };

        function keyUpDown(down, $event) {
          // windows ctrl = 17, OSX cmd = 91
          if ($event.keyCode === 17 || $event.keyCode === 91) {
            isCtrlDown = down;
          }
          // c-button
          if ($event.keyCode === 67) {
            isCDown = down;
          }

          if (isCtrlDown && isCDown) {
            dialogVm.closeDialog();
            copySuccess();
          }
        }
      }
    }
  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('LinkParserService', LinkParserService);

  /** @ngInject */
  function LinkParserService($location) {
    var service = {
      parse: parseLinks
    };
    return service;

    function parseLinks(text) {
      if (!text) {
        return;
      }
      var linkBeginTxt = '<link>', linkEndTxt = '</link>', linkLevelTxt = '€', linkIdTxt = '£';
      var linkStart, linkEnd, linkLevel, linkId, linkText;
      var linkStartLength = 6, linkEndLength = 7;
      var parsedText = '';

      var level, id, linkDescription;

      while ((linkStart = text.indexOf(linkBeginTxt)) !== -1) {
        linkEnd = text.indexOf(linkEndTxt);
        linkText = text.substring(linkStart + linkStartLength, linkEnd);

        linkLevel = linkText.indexOf(linkLevelTxt);
        linkId = linkText.indexOf(linkIdTxt);

        linkDescription = linkText.substring(0, linkLevel);
        level = linkText.substring(linkLevel + 1, linkId).toLowerCase();
        id = linkText.substring(linkId + 1, linkEnd);

        parsedText += text.substring(0, linkStart); // Add text before link
        parsedText += '<a class="md-accent" href="' + getUrl(level, id) + '" onclick="event.stopPropagation();">' + linkDescription + '</a>';

        text = text.substring(linkEnd + linkEndLength, text.length);
      }
      parsedText += text;
      return parsedText;
    }

    function getUrl(level, id) {
      if (!id) {
        id = '';
      }
      var baseUrl = '#/';
      if (/^\/preview-edits\//.test($location.path())) {
        baseUrl += 'preview-edits/'
      }
      switch (level) {
        case 'category':
          baseUrl += 'category/';
          break;
        case 'subcategory':
          baseUrl += 'subcategory/';
          break;
        case 'mainsymptom':
          baseUrl += 'main-symptom/';
          break;
        case 'manual':
          baseUrl += 'manual/';
          break;
        case 'symptom':
          baseUrl += 'symptom/';
          break;
        case 'solution':
          baseUrl += 'solution/';
          break;
        }
      return baseUrl + id;
    }
  }

})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('LeftMenuService', LeftMenuService);

  /** @ngInject */
  function LeftMenuService(Category, Manual) {
    var service = {
      get: get,
      items: [],
      setType: setTypeOrHide,
      type: 'categories',
      show: true
    };
    return service;

    function get() {
      var params = {};
      // if (/^\/preview-edits\//.test($location.path())) {
        params.version = 'tonttu';
      // }
      switch (service.type) {
        case 'categories':
          return service.items = Category.query(params);
        case 'manual':
          return service.items = Manual.query(params);
        default:
          return;
      }
    }

    function setTypeOrHide(type) {
      if (type === 'none') {
        service.show = false;
        service.type = 'none';
      } else {
        service.show = true;
        service.type = type;
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .directive('leftMenu', leftMenu);

  /** @ngInject */
  function leftMenu(LeftMenuService, AuthenticationService) {
    var directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/leftMenu/leftMenu.html',
      controller: LeftMenuController,
      controllerAs: 'list',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function LeftMenuController($scope, $location, LocationService) {
      var vm = this;
      vm.service = LeftMenuService;
      vm.auth = AuthenticationService;
      vm.isTHB = LocationService.isTHB;
      vm.isSkane = /skane.triagehandboken.se$/i.test($location.host());

      // Make service fetch items as this directive is created.
      // Also make sure that the list is re-fetched when the user signs in
      // and when the type in the service changes
      var destroyCallbacks = [];
      destroyCallbacks.push($scope.$on('login', LeftMenuService.get));
      destroyCallbacks.push($scope.$watch(function() {
        return vm.service.type + /^\/preview-edits\//.test($location.path());
      }, vm.service.get));

      // set up clean up
      $scope.$on('$destroy', cleanUp.bind(vm, destroyCallbacks));

      vm.navigate = navigate;

      function navigate($event, id) {
        var prefix = '/';
        if (/^\/preview-edits\//.test($location.path())) {
          prefix = 'preview-edits/';
        }
        switch (vm.service.type) {
          case 'categories':
            $location.url(prefix + 'category/' + id);
            break;
          case 'manual':
            $location.url(prefix + 'manual/' + id);
            break;
        }
      }


    }

    /**
     * Calls each callback in the array
     * @param  {array} destroyCallbacks An array of callbacks
     */
    function cleanUp(destroyCallbacks) {
      _.each(destroyCallbacks, function(destroy) {
        destroy();
      });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .directive('cookieNotification', cookieNotification);

  /** @ngInject */
  function cookieNotification() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cookieNotification/cookieNotification.html',
      controller: CookieNotificationController,
      controllerAs: '$ctrl',
      bindToController: true,
      scope: {}
    };

    var COOKIE_KEY = 'allow_cookies';

    return directive;

    /** @ngInject */
    function CookieNotificationController($cookies) {
      var vm = this;
      vm.showCookieNotification = $cookies.get(COOKIE_KEY) !== 'true';

      vm.allowCookies = allowCookies;

      function allowCookies() {
        $cookies.put(COOKIE_KEY, 'true', { expires: moment().add(10, 'y').toDate() });
        vm.showCookieNotification = false;
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .directive('capitalize', CapitalizeDirective);

  /** @ngInject */
  function CapitalizeDirective() {
    var directive = {
      require: 'ngModel',
      link: CapitalizeLink
    };

    return directive;

    function CapitalizeLink(scope, element, attrs, ngModelController) {
      ngModelController.$parsers.push(function (input) {
        //convert data from view format to model format
        return _.upperFirst(input); //converted
      });

      ngModelController.$formatters.push(function (input) {
        //convert data from model format to view format
        return _.upperFirst(input); //converted
      });
    }
  }

})();
(function() {
  'use strict';

  angular
  .module('thb')
  .factory('BreadCrumbsService', BreadCrumbsService);

  /** @ngInject */
  function BreadCrumbsService() {
    var service = {
      breadCrumbs: [],
      crumble: crumble,
      manualCrumb: manualCrumb,
      getCopyLocation: getCopyLocation
    };
    return service;

    /**
     * Updates the list of breadcrumbs.
     * @param  {Object} breadCrumbs The response object
     */
    function crumble(breadCrumbs) {
      if (!Array.isArray(breadCrumbs)) {
        return;
      }
      service.breadCrumbs = breadCrumbs;
    }

    /**
     * Adds a bread crumb manually, for instance a page title
     * @param  {String} name the breadcrumb title
     * @return {undefined}       nothing
     */
    function manualCrumb(name) {
      service.breadCrumbs.length = 0;
      service.breadCrumbs.push({name: name});
    }

    /**
     * Returns the breadcrumb titles separated by >
     * @return {String} The string
     */
    function getCopyLocation() {
      var titles = _.map(service.breadCrumbs, 'name');
      return _.reduce(titles, function (text, title) {
        return text + " > " + title;
      }, 'Triagehandboken');
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .directive('breadCrumbs', breadCrumbs);

  /** @ngInject */
  function breadCrumbs(BreadCrumbsService, $animate, $window, $location, $mdMedia) {
    var directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/breadCrumbs/breadCrumbs.html',
      controller: BreadCrumbsController,
      controllerAs: '$ctrl',
      bindToController: true,
      link: prepareAnimations
    };

    var crumbWidths = [];

    return directive;

    /** @ngInject */
    function BreadCrumbsController($scope, LocationService) {
      var vm = this;
      vm.$mdMedia = $mdMedia;
      vm.offset = { 'margin-left': '0px' };
      vm.service = BreadCrumbsService;
      vm.kebabCase = _.kebabCase;
      vm.isFrontPage = LocationService.isFrontPage;

      $scope.$watch(function () {
        return $location.path();
      }, function (newPath) {
        vm.prefix = /^\/preview-edits\//.test(newPath) ? '/preview-edits' : '';
      });
    }

    function prepareAnimations(scope, crumbsContainer) {
      var list = crumbsContainer[0].children[0];
      $animate.on('leave', list, shiftRight);
      $animate.on('enter', list, shiftLeft);

      function shiftLeft(newCrumb, phase) {
        if (phase === 'close') {
          scope.$apply(function () {
            var totalWidth = crumbsContainer[0].clientWidth;
            crumbWidths.push({
              node: newCrumb[0],
              width: newCrumb[0].scrollWidth
            });
            var childrenWidth = _.sum(_.map(crumbWidths, 'width'));
            if (childrenWidth > totalWidth) {
              scope.offset = { 'margin-left': (totalWidth - childrenWidth) + 'px' };
            }
          });
        }
      }

      function shiftRight(leaveCrumb, phase) {
        if (phase === 'close') {
          scope.$apply(function () {
            var totalWidth = crumbsContainer[0].clientWidth;
            var childrenWidth = _.sum(_.map(crumbWidths, 'width'));
            var removed = _.remove(crumbWidths, 'node', leaveCrumb[0]);
            childrenWidth -= removed.width;
            // if the new set of children is larger than the bar, set new margin
            if (childrenWidth > totalWidth) {
              scope.offset = { 'margin-left': (totalWidth - childrenWidth) + 'px' };
            } else {
              scope.offset = { 'margin-left': '0px' };
            }
          });
        }
      }

      /*
       * Listen to window resize event
       */
      angular.element($window).bind('resize', _.debounce(resize, 150));

      function resize() {
        scope.$apply(function () {
          var totalWidth = crumbsContainer[0].clientWidth;
          var childrenWidth = _.sum(_.map(crumbWidths, 'width'));
          if (childrenWidth > totalWidth) {
            scope.offset = { 'margin-left': (totalWidth - childrenWidth) + 'px' };
          } else {
            scope.offset = { 'margin-left': '0px' };
          }
        });
      }

    }
  }

})();

(function() {
    'use strict';

    angular
        .module('thb')
        .directive('bottomNav', bottomNav);

    /** @ngInject */
    function bottomNav() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/bottomNav/bottomNav.html',
            controller: BottomNavController,
            controllerAs: '$bot',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function BottomNavController($scope, $window) {
            var vm = this;
            vm.canGoBack = canGoBack;
            vm.canGoForward = canGoForward;
            vm.goBack = goBack;
            vm.goForward = goForward;
            vm.isStandalone = ("standalone" in $window.navigator) && $window.navigator.standalone;

            $scope.$watch(
                function() { return $window.history.length },
                function(newVal) {
                    vm.currentIndex = newVal;
                }
            );

            function canGoBack() {
                return 0 < vm.currentIndex;
            }

            function canGoForward() {
                return vm.currentIndex < $window.history.length;
            }

            function goBack() {
                $window.history.back();
                --vm.currentIndex;
            }

            function goForward() {
                $window.history.forward();
                ++vm.currentIndex;
            }

        }
    }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .factory('AuthenticationService', AuthenticationService);

    /** @ngInject */
    function AuthenticationService($base64, $rootScope, User, $location, $localStorage, Raven) {
      var service = {
        user: {},
        login: login,
        logout: logout,
        isEndpoint: isEndpoint,
        addEndpoint: addEndpoint,
        getToken: getToken,
        recordActivity: recordActivity,
        isAuthenticated: isAuthenticated,
        hasRole: hasRole,
        isPasswordValid: isPasswordValid
      };

      var token, tokenExpires, endpoints = [], expirationTime = 2*60*60*1000, lastActivity;

      // a trick
      var urlParser = angular.element('<a></a>')[0];

      token = $localStorage.token;
      var userId = $localStorage.userId;
      if (token && userId) {
        tokenExpires = moment.unix($localStorage.expires);
        if (tokenExpires.isAfter(moment())) {
          User.get({id: userId})
            .$promise
            .then(setUser, logout)
            .finally(function() {
              $rootScope.$on('authentication-failed', function() {
                if (isAuthenticated()) {
                  logout();
                  $location.url('/login?redirectedFrom=' + $base64.encode(encodeURI($location.url())));
                }
              });
            });
        } else {
          logout();
        }
      }

      return service;

      function isAuthenticated() {
        return token && (!hasRole('admin') || Date.now()-lastActivity < expirationTime);
      }

      function login(username, password) {
        var promise = User.login({username: username, password: password}).$promise;
        promise.then(setUser).then(function (user) {
          setToken(username, user.sessionToken || password);
          if (user.sessionToken) {
            $localStorage.token = token;
            $localStorage.expires = tokenExpires.unix();
          }
          $rootScope.$broadcast('login');
        }, function (err) {
          logout();
          return err;
        });
        return promise;
      }

      function isPasswordValid(password) {
        var tempToken = 'Basic ' + $base64.encode(service.user.username + ':' + password);
        return tempToken === token;
      }

      function logout() {
        token = $localStorage.token = $localStorage.userId = $localStorage.expires = undefined;
        service.user = {};
        Raven.setUserContext(); // Unset user context
        $rootScope.$broadcast('logout');
      }

      function getToken() {
        if (isAuthenticated()) {
          return token;
        }
        logout();
      }

      function isEndpoint(url) {
        urlParser.href = url;
        var hostname = urlParser.hostname;
        var found = false;
        endpoints.forEach(function (endpoint) {
          if (endpoint === hostname) {
            found = true;
          }
        });
        return found;
      }

      function addEndpoint(url) {
        urlParser.href = url;
        var hostname = urlParser.hostname;
        endpoints.push(hostname);
      }

      function setUser(user) {
        // Set permissions
        user.role = ['reader', user.role];
        service.user = user;
        $localStorage.userId = user.id;
        Raven.setUserContext({
          userId: user.id
        });
        return user;
      }

      function setToken(username, password) {
        token = 'Basic ' + $base64.encode(encodeURIComponent(username + ':' + password).replace(/%([0-9A-F]{2})/g, function(match, p1) {
            return String.fromCharCode('0x' + p1);
          }));
        tokenExpires = moment().add(2, 'w').subtract(1, 'm');
        recordActivity();
        return token;
      }

      function hasRole(role) {
        return _.includes(service.user.role, role);
      }

      function recordActivity() {
        lastActivity = Date.now()
      }
    }

})();

(function () {

  angular
  .module('thb')
  .factory('AuthenticationInterceptor', AuthenticationInterceptor);

  /** @ngInject */
  function AuthenticationInterceptor($rootScope, $q, $injector) {
    var intercept = {
      request: interceptRequest,
      responseError: interceptResponseError
    };

    return intercept;

    function interceptRequest(config) {
      //injected manually to get around circular dependency problem.
      var AuthenticationService = $injector.get('AuthenticationService');
      if(AuthenticationService.isEndpoint(config.url)) {
        var token = AuthenticationService.getToken();
        if (token) {
          config.headers.Authorization = token;
          AuthenticationService.recordActivity();
        }
      }
      return config;
    }

    function interceptResponseError(rejection) {
      if (rejection.status === 401) {
        $rootScope.$broadcast('authentication-failed');
      }
      return $q.reject(rejection);
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('thb')
  .factory('User', UserResource);

  /** @ngInject */
  function UserResource($resource, THB_URL) {
    /*
    :options is for instance account-types, roles, etc. although
     */
    var resource = $resource(THB_URL + '/users/:id/:options', {
      id: '@id'
    }, {
      update: {
        method: 'PUT'
      },
      login: {
        method: 'POST',
        url: THB_URL + '/users/login'
      }
    });

    return resource;
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController(User, $mdEditDialog, $mdDialog, $mdToast, $q) {
      var vm = this;
      vm.User = User;
      vm.query = {
        page: 1,
        limit: 20,
        order: '-registered'
      };
      vm.selected = [];
      vm.months = 1;
      vm.refresh = refresh;
      vm.approve = approveSelected;
      vm.deny = denySelected;
      vm.editText = editText;
      vm.saveUser = saveUser;
      // get account types
      vm.User.query({options: 'account-types'}).$promise
      .then(function (accountTypes) {
        accountTypes.push('all');
        vm.accountTypes = accountTypes.sort();
        vm.type = 'all';
      });
      // get roles
      vm.User.query({options: 'roles'}).$promise
      .then(function (roles) {
        vm.roles = roles;
      });
      refresh();

      function refresh() {
        vm.selected.length = 0;
        vm.users = vm.User.query({type: vm.type === 'all' ? undefined : vm.type});
        vm.promise = vm.users.$promise;
      }

      function approveSelected() {
        var promises = _.map(vm.selected, approveUser.bind(null, vm.months));
        var msg = vm.selected.length + ' konton har aktiverats i ' + vm.months + ' månader';
        $q.all(promises)
        .then(success.bind(null, msg))
        .catch(error.bind(null, 'En del av användarna kunde inte sparas. Error: '));
      }

      function approveUser(months, user) {
        var expirationDate = moment().startOf('day').add(months, 'months');
        user.expires = expirationDate.toISOString();
        user.accountType = 'trial';
        var promise = User.update(user).$promise;
        promise.then(function() {}, function(response) {
          $q.reject(response);
        });
        return promise;
      }

      function denySelected() {
        var msg = 'Är du säker på att du vill ta bort dessa ' +
        vm.selected.length + ' användarna?'
        $mdDialog.show(
          $mdDialog.confirm()
          .clickOutsideToClose(false)
          .title(msg)
          .textContent()
          .ariaLabel('Are you sure?')
          .ok('JAAA')
          .cancel('NAJ NAJ')
        ).then(function () {
          var promises = _.map(vm.selected, function (user) {
            user.accountType = 'deleted';
            var promise = User.update(user).$promise;
            promise.then(function () {}, function(response) {
              $q.reject(response);
            });
            return promise;
          });
          $q.all(promises)
          .then(success.bind(null, 'Användarna har tagits bort'))
          .catch(error.bind(null, 'Något gick fel =( '));
        });
      }

      function editText($event, user, fieldName) {
        // if auto selection is enabled you will want to stop the event
        // from propagating and selecting the row
        $event.stopPropagation();

        /*
         * messages is commented out because there is a bug currently
         * with ngRepeat and ngMessages were the messages are always
         * displayed even if the error property on the ngModelController
         * is not set, I've included it anyway so you get the idea
         */

        $mdEditDialog.small({
          modelValue: user[fieldName],
          placeholder: _.startCase(fieldName),
          save: saveUserFromField.bind(null, user, fieldName),
          targetEvent: event
          // validators: {
          //   'md-maxlength': 30
          // }
        });
      }

      function saveUserFromField(user, fieldName, input) {
        user[fieldName] = input.$modelValue;
        saveUser(user);
      }

      function saveUser(user) {
        user.$update()
        .then(success.bind(null, "Användaren har uppdaterats"))
        .catch(function error(reason) {
          error('Användaren kunde inte uppdateras. Error: ', reason);
          //reset user object
          user = user.get({id: user.id});
        });
      }

        function success(msg) {
          $mdToast.show(
            $mdToast.simple()
            .textContent(msg)
            .position('top right')
          );
        }

        function error(msg, reason) {
          $mdDialog.show(
            $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Fel!')
            .textContent(msg + reason)
            .ariaLabel('Feldialog')
            .ok('OK')
          );
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('AccountSettingsController', AccountSettingsController);

  /** @ngInject */
  function AccountSettingsController($mdDialog, $base64, $location, $http,
    THB_URL, $mdToast, AuthenticationService, User, $document) {

    var vm = this;
    vm.user = _.cloneDeep(AuthenticationService.user);
    vm.changePassword = changePassword;
    vm.updateUserInfo = updateUserInfo;

    var USERINFO_SUCCESS = 'Dina kontaktuppgifter har uppdaterats.';
    var USERINFO_FAIL = 'Något gick fel när dina kontaktuppgifter. ' +
    'Försök igen senare eller kontakta oss.';
    var PASSWORD_SUCCESS = 'Ditt lösenord har uppdaterats.';
    var PASSWORD_FAIL = 'Något gick fel när ditt lösenord skulle sparas. ' +
    'Försök igen senare eller kontakta oss.';

    function updateUserInfo(event) {
      delete vm.user.role;
      User.update(vm.user).$promise
      .then(
        success.bind(null, USERINFO_SUCCESS),
        fail.bind(null, event, USERINFO_FAIL
      ))
      .then(function () {
        // reset user
        _.merge(AuthenticationService.user, vm.user);
      });
    }

    function changePassword(event) {
      User.update({id: vm.user.id, hash: vm.hash}).$promise
      // update password
      .then(AuthenticationService.login.bind(null, vm.user.username, vm.hash))
      .then(
        success.bind(null, PASSWORD_SUCCESS),
        fail.bind(null, event, PASSWORD_FAIL)
      ).then(function () {
        vm.hash = vm.confirm = vm.currentPassword = undefined;
        vm.passwordForm.$setUntouched();
        vm.passwordForm.$setPristine();
      });
    }

    function success(message) {
      $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .position('top right')
        .parent(angular.element($document[0].querySelector(".content")))
      );
    }

    function fail(event, message) {
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Fel!')
        .textContent(message)
        .ariaLabel('Feldialog')
        .ok('OK')
        .targetEvent(event);
      $mdDialog.show(dialog);
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .factory('AccountLog', AccoutLogItemResource);

  /** @ngInject */
  function AccoutLogItemResource($resource, THB_URL) {

    return $resource(THB_URL + '/log/:id/', {
      id: '@id'
    }, {
      update: {
        method: 'PUT'
      }
    });
  }

  angular
    .module('thb')
    .factory('AccountLogService', AccountLogService);

  /** @ngInject */
  function AccountLogService(AccountLog, $rootScope) {
    // clear log on logout
    $rootScope.$on('logout', emptyLog);

    var service = {
      items: [],
      refresh: refreshFirstWeek,
      next: next,
      isBusy: false
    };

    return service;

    function refreshFirstWeek() {
      service.isBusy = true;
      return AccountLog.query({ from: moment().toISOString(), days: 7, version: 'tonttu' }).$promise
        .then(extractDaysAndDate)
        .then(checkIfMore)
        .then(putFirst)
        .then(toggleBusy);
    }

    /**
     * Get log items from the next date onward, or the current date
     */
    function next() {
      if (service.isBusy)
        return;
      toggleBusy();
      var lastDay = _.last(service.items);
      return AccountLog.query({
        from: moment(lastDay.date).subtract(1, 'day').endOf('day').toISOString(),
        version: 'tonttu'
      }).$promise
        .then(extractDaysAndDate)
        .then(checkIfMore)
        .then(putLast)
        .then(toggleBusy);
    }

    /**
     * Group the log entries in the response by day and set last day.
     */
    function extractDaysAndDate(res) {
      return _.chain(res)
        .groupBy(function (item) {
          return moment(item.date).startOf('day').format();
        }).reduce(function (coll, val, key) {
          coll.push({
            decisions: val,
            date: key
          });
          return coll;
        }, [])
        .sortBy(function (item) {
          return moment(_.head(item.decisions).date).toDate();
        })
        .reverse()
        .value();
    }

    function checkIfMore(items) {
      if (_.isEmpty(items)) {
        service.noMoreDays = true;
      }
      return items;
    }

    function toggleBusy() {
      service.isBusy = !service.isBusy;
    }

    function putLast(moreItems) {
      var firstDay = _.pullAt(moreItems, 0)[0];
      var lastDay = _.last(service.items);
      if (firstDay) {
        if (firstDay.date === lastDay.date) {
          lastDay.decisions = _.uniqBy(_.concat(lastDay.decisions, firstDay.decisions), 'id');
        } else {
          service.items.push(firstDay);
        }
        service.items = _.concat(service.items, moreItems);
      }
    }

    // remove items after or on same day as the last new item and put
    // in the new ones
    function putFirst(refreshedItems) {
      var lastNewDay = _.last(refreshedItems);
      if (!lastNewDay) {
        return emptyLog();
      }
      lastNewDay = moment.parseZone(lastNewDay.date);
      if (!service.items.length) {
        service.items = refreshedItems;
        return;
      }
      _.remove(service.items, function (item) {
        return moment.parseZone(item.date).isSameOrAfter(lastNewDay, 'day');
      });
      service.items = _.concat(refreshedItems, service.items);
    }

    function emptyLog() {
      service.items.length = 0;
      service.lastDay = undefined;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('thb')
    .controller('AccountLogController', AccountLogController);

  /** @ngInject */
  function AccountLogController(AccountLogService, moment, $document, $timeout) {
    var vm = this;
    vm.DECISION_LIMIT = 4;
    vm.getDayLimit = getDayLimit;
    vm.getRemainingDecisions = getRemainingDecisions;
    vm.isNewMonth = isNewMonth;
    vm.gapBetweenDays = gapBetweenDays;
    vm.getElapsedTime = getElapsedTime;
    vm.service = AccountLogService;
    vm.service.refresh();

    $timeout(function() {
      vm.scrollContainer = angular.element($document[0].querySelector("md-content[ng-view]"))
    }, 300)

    function getDayLimit(day) {
      return day.expanded ? day.decisions.length : vm.DECISION_LIMIT;
    }

    function getRemainingDecisions(day) {
      var remainingDecisions = day.decisions.length - vm.DECISION_LIMIT;
      return remainingDecisions < 9 ? remainingDecisions : '*';
    }

    function isNewMonth(dayIndex) {
      return isDifferent(dayIndex, 0, 'months')
    }

    function gapBetweenDays(dayIndex) {
      return isDifferent(dayIndex, 1, 'days');
    }

    function getElapsedTime(dayIndex) {
      if (vm.service.items.length === dayIndex + 1)
        return;
      var currentDate = moment(vm.service.items[dayIndex].date),
        nextDate = moment(vm.service.items[dayIndex + 1].date);
      var tryPeriods = [
        { en: 'years', sv: ['år', 'år'] },
        { en: 'months', sv: ['månad', 'månader'] },
        { en: 'weeks', sv: ['vecka', 'veckor'] },
        { en: 'days', sv: ['dag', 'dagar'] }
      ];
      var found;
      _.find(tryPeriods, function (period) {
        var diff = currentDate.diff(nextDate, period.en);
        if (diff > 0) {
          found = diff;
          // use diff as index, if diff > 1, we need to print the plural version, so use index 2
          if (diff > 1) {
            diff = 2;
          }
          found += ' ' + period.sv[diff - 1];
          return true;
        }
      });
      return found;
    }

    function isDifferent(dayIndex, tolerance, measure) {
      // If it's the last day, dont show the separator
      if (vm.service.items.length === dayIndex + 1)
        return false;

      var currentDay = vm.service.items[dayIndex],
        nextDay = vm.service.items[dayIndex + 1];
      return moment(currentDay.date).diff(moment(nextDay.date), measure) > tolerance;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/thb/news/news.html',
        controller: 'NewsController',
        controllerAs: '$ctrl',
        data: {
          title: 'Nyheter',
          leftMenuType: 'categories',
          copy: true,
          search: true
        },
        resolve: {
          news: function(ThbLoaderService, News) {
            return ThbLoaderService.load(News.query);
          }
        }

      })
      .when('/news', {
        templateUrl: 'app/thb/news/news.html',
        controller: 'NewsController',
        controllerAs: '$ctrl',
        data: {
          title: 'Nyheter',
          leftMenuType: 'categories',
          copy: true,
          search: true
        },
        resolve: {
          news: function(ThbLoaderService, News) {
            return ThbLoaderService.load(News.query);
          }
        }

      })
      .when('/category/:id', {
        templateUrl: 'app/thb/category/category.html',
        controller: 'CategoryController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          category: function(ThbLoaderService, Category, $route) {
            return ThbLoaderService.load(Category.get, $route.current.params.id);
          }
        }
      })
      .when('/subcategory/:id', {
        templateUrl: 'app/thb/subCategory/subCategory.html',
        controller: 'SubCategoryController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          subcategory: function(ThbLoaderService, Subcategory, $route) {
            return ThbLoaderService.load(Subcategory.get, $route.current.params.id);
          }
        }
      })
      .when('/main-symptom/:id', {
        templateUrl: 'app/thb/mainSymptom/mainSymptom.html',
        controller: 'MainSymptomController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          mainSymptom: function(ThbLoaderService, MainSymptom, $route) {
            return ThbLoaderService.load(MainSymptom.get, $route.current.params.id);
          }
        }
      })
      .when('/symptom/:id', {
        templateUrl: 'app/thb/symptom/symptom.html',
        controller: 'SymptomController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          symptom: function(ThbLoaderService, Symptom, $route) {
            return ThbLoaderService.load(Symptom.get, $route.current.params.id);
          }
        }
      })
      .when('/manual', {
        templateUrl: 'app/thb/manual/manual.html',
        controller: 'ManualController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'manual',
          title: 'Manual',
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          manualItem: function(ThbLoaderService, Manual) {
            return ThbLoaderService.load(Manual.query);
          }
        }
      })
      .when('/manual/:id', {
        templateUrl: 'app/thb/manual/manual.html',
        controller: 'ManualController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'manual',
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          manualItem: function(ThbLoaderService, Manual, $route) {
            return ThbLoaderService.load(Manual.get, $route.current.params.id || 1);
          }
        }
      })

      // COPY PASTE FOR EDIT PREVIEW

      .when('/preview-edits/', {
        templateUrl: 'app/thb/news/news.html',
        controller: 'NewsController',
        controllerAs: '$ctrl',
        data: {
          title: 'Nyheter',
          leftMenuType: 'categories',
          copy: true,
          search: true
        },
        resolve: {
          news: function(ThbLoaderService, News) {
            return ThbLoaderService.load(News.query);
          }
        }

      })
      .when('/preview-edits/news', {
        templateUrl: 'app/thb/news/news.html',
        controller: 'NewsController',
        controllerAs: '$ctrl',
        data: {
          title: 'Nyheter',
          leftMenuType: 'categories',
          copy: true,
          search: true
        },
        resolve: {
          news: function(ThbLoaderService, News) {
            return ThbLoaderService.load(News.query);
          }
        }

      })
      .when('/preview-edits/category/:id', {
        templateUrl: 'app/thb/category/category.html',
        controller: 'CategoryController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          category: function(ThbLoaderService, Category, $route) {
            return ThbLoaderService.load(Category.get, $route.current.params.id);
          }
        }
      })
      .when('/preview-edits/subcategory/:id', {
        templateUrl: 'app/thb/subCategory/subCategory.html',
        controller: 'SubCategoryController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          subcategory: function(ThbLoaderService, Subcategory, $route) {
            return ThbLoaderService.load(Subcategory.get, $route.current.params.id);
          }
        }
      })
      .when('/preview-edits/main-symptom/:id', {
        templateUrl: 'app/thb/mainSymptom/mainSymptom.html',
        controller: 'MainSymptomController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          mainSymptom: function(ThbLoaderService, MainSymptom, $route) {
            return ThbLoaderService.load(MainSymptom.get, $route.current.params.id);
          }
        }
      })
      .when('/preview-edits/symptom/:id', {
        templateUrl: 'app/thb/symptom/symptom.html',
        controller: 'SymptomController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'categories',
          hasColor: true,
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          symptom: function(ThbLoaderService, Symptom, $route) {
            return ThbLoaderService.load(Symptom.get, $route.current.params.id);
          }
        }
      })
      .when('/preview-edits/manual', {
        templateUrl: 'app/thb/manual/manual.html',
        controller: 'ManualController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'manual',
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          manualItem: function(ThbLoaderService, Manual) {
            return ThbLoaderService.load(Manual.query);
          }
        }
      })
      .when('/preview-edits/manual/:id', {
        templateUrl: 'app/thb/manual/manual.html',
        controller: 'ManualController',
        controllerAs: '$ctrl',
        data: {
          leftMenuType: 'manual',
          authenticate: true,
          copy: true,
          search: true
        },
        resolve: {
          manualItem: function(ThbLoaderService, Manual, $route) {
            return ThbLoaderService.load(Manual.get, $route.current.params.id || 1);
          }
        }
      });

  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($routeProvider) {
    $routeProvider
      .when('/login', {
        templateUrl: 'app/public/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        data: {
          authenticate: false,
          title: 'Logga in',
          leftMenuType: 'none'
        }
      })
      .when('/register', {
        templateUrl: 'app/public/register/register.html',
        controller: 'RegistrationController',
        controllerAs: 'register',
        data: {
          authenticate: false,
          title: 'Anmäl intresse',
          leftMenuType: 'none'
        }
      })
      .when('/forgot-password', {
        templateUrl: 'app/public/password/forgot/forgot.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'fp',
        data: {
          authenticate: false,
          title: 'Glömt lösenord',
          leftMenuType: 'none'
        }
      })
      .when('/reset-password', {
        templateUrl: 'app/public/password/reset/reset.html',
        controller: 'ResetPasswordController',
        controllerAs: 'rp',
        data: {
          authenticate: false,
          title: 'Återställ lösenord',
          leftMenuType: 'none'
        }
      })
      .when('/cookies', {
        'templateUrl': 'app/public/cookies/cookies.html',
        data: {
          title: 'Cookies',
          leftMenuType: 'none'
        }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .controller('FeedbackController', FeedbackController);

  /** @ngInject */
  function FeedbackController(
    $mdDialog,
    $base64,
    $location,
    $http,
    THB_URL,
    $mdToast,
    AuthenticationService,
    $document) {

    var vm = this;
    vm.submit = submit;
    vm.auth = AuthenticationService;

    function submit(event) {
      $http({
        method: 'POST',
        url: THB_URL + '/feedback',
        data: {
          topic: vm.topic,
          message: vm.message,
          senderMail: AuthenticationService.user.username,
          senderName: AuthenticationService.user.firstName,
          location: 'feedback'
        }
      }).then(success.bind(null, event), fail.bind(null, event));
    }

    function success() {
      vm.topic = vm.message = undefined;
      vm.form.$setUntouched();
      vm.form.$setPristine();
      var content = 'Tack för din feedback!';
      $mdToast.show(
        $mdToast.simple()
        .textContent(content)
        .position('top right')
        .parent(angular.element($document[0].querySelector(".content")))
      );
    }

    function fail(event) {
      var content = 'Något gick fel när din feedback skulle skickas. ' +
      'Försök igen senare eller kontakta oss.';
      var dialog = $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Fel!')
        .textContent(content)
        .ariaLabel('Feldialog')
        .ok('OK')
        .targetEvent(event);
      $mdDialog.show(dialog);
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($routeProvider) {
    $routeProvider
      .when('/admin/users', {
        templateUrl: 'app/admin/users/users.html',
        controller: 'UsersController',
        controllerAs: '$ctrl',
        data: {
          title: 'Hantera användare',
          leftMenuType: 'none',
          authenticate: true
        }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($routeProvider) {
    $routeProvider
      .when('/account/settings', {
        templateUrl: 'app/account/settings/settings.html',
        controller: 'AccountSettingsController',
        controllerAs: '$ctrl',
        data: {
          title: 'Kontoinställningar',
          leftMenuType: 'none',
          authenticate: true
        }
      }).when('/account/logs', {
        templateUrl: 'app/account/log/log.html',
        controller: 'AccountLogController',
        controllerAs: '$ctrl',
        data: {
          title: 'Triagehistorik',
          leftMenuType: 'none',
          authenticate: true
        }
      });
  }

})();

angular.module("thb.config", [])

.constant("ENV", "production")

.constant("THB_URL", "https://triagehandboken.se/api")

.constant("GIT_COMMIT", "not set")

.constant("GIT_BRANCH", "not set")

;
(function() {
  'use strict';

  angular
    .module('thb')
    .run(Setup);

  /** @ngInject */
  function Setup($log,
                 $rootScope,
                 AuthenticationService,
                 THB_URL,
                 ThemingService,
                 BreadCrumbsService,
                 LeftMenuService,
                 NavBarService,
                 $location,
                 amMoment,
                 $base64,
                 GIT_COMMIT,
                 Raven,
                 ENV) {

    // Authentication
    AuthenticationService.addEndpoint(THB_URL);

    // Bread crumbs listener
    var destroyCallback = $rootScope.$on('$routeChangeStart', routeChangeStart);
    $rootScope.$on('$destroy', destroyCallback);

    // date locale
    amMoment.changeLocale('se');

    if (ENV === 'production') {
      Raven.setRelease(GIT_COMMIT);
    }
    Raven.setEnvironment(ENV);


    // Route changes
    function routeChangeStart(event, next) {
      // check if we need to be authenticated or if we shouldnt
      if (next.data) {
        if (next.data.authenticate && !AuthenticationService.isAuthenticated()) {
          $location.url('/login?redirectedFrom=' + $base64.encode(encodeURI($location.url())));
        } else if (next.data.authenticate !== undefined && !next.data.authenticate) {
          //authenticate is explicitly set to false
          if (AuthenticationService.isAuthenticated()) {
            event.preventDefault();
            return;
          }

        }

        // Set manual breadcrumb if exists
        if (next.data.title) {
          BreadCrumbsService.manualCrumb(next.data.title);
        }
        if (!next.data.hasColor) {
          ThemingService.setTheme('default');
        }

        NavBarService.showSearch = !!next.data.search;

        // Update the left-menu to display the correct items
        LeftMenuService.setType(next.data.leftMenuType);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($routeProvider) {
    $routeProvider
      .when('/feedback', {
        templateUrl: 'app/feedback/feedback.html',
        controller: 'FeedbackController',
        controllerAs: 'feedback',
        data: {
          title: 'Lämna feedback',
          leftMenuType: 'none',
          authenticate: true
        }
      })
      .otherwise({
        redirectTo: '/'
      });

  }

})();

(function() {
  'use strict';

  // angular
  //   .module('thb')
  //   .constant('THB_URL', 'https://52.16.193.189/api/');

})();

(function() {
  'use strict';

  angular
    .module('thb')
    .config(config);

  /** @ngInject */
  function config($provide, $logProvider, $mdThemingProvider, $httpProvider,
    $mdGestureProvider, $mdDateLocaleProvider, moment, ENV) {

    // Enable log
    if (ENV === 'development') {
      $logProvider.debugEnabled(true);
      // $analyticsProvider.developerMode(true);
    }
    // https://github.com/angular/material/issues/1826
    $mdGestureProvider.skipClickHijack();

    moment.updateLocale('sv', {
      calendar: {
        lastDay: '[Igår,] dddd',
        sameDay: '[Idag,] dddd',
        nextDay: '[Imorgon,] dddd',
        lastWeek: 'dddd',
        nextWeek: 'dddd',
        sameElse: 'dddd'
      }
    });

    $httpProvider.interceptors.push('AuthenticationInterceptor');

    $mdThemingProvider.disableTheming();

    var months = [
      'januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti',
      'september', 'oktober', 'november', 'december'
    ];

    var shortMonths = [
      'jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt',
      'nov', 'dec'
    ];

    var weekDays = [
      'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag', 'söndag'
    ];

    var shortWeekDays = ['mån', 'tis', 'ons', 'tor', 'fre', 'lör', 'sön'];

    $mdDateLocaleProvider.months = months;
    $mdDateLocaleProvider.shortMonths = shortMonths;
    $mdDateLocaleProvider.days = weekDays;
    $mdDateLocaleProvider.shortDays = shortWeekDays;
    // Can change week display to start on Monday.
    $mdDateLocaleProvider.firstDayOfWeek = 0;

    $mdDateLocaleProvider.parseDate = function(dateString) {
      var m = moment(dateString, 'YYYY-MM-DD', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };
    $mdDateLocaleProvider.formatDate = function(date) {
      return moment(date).format('YYYY-MM-DD');
    };
    $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
      return shortMonths[date.getMonth()] + ' ' + date.getFullYear();
    };
    // In addition to date display, date components also need localized messages
    // for aria-labels for screen-reader users.
    $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
      return 'Vecka ' + weekNumber;
    };
    $mdDateLocaleProvider.msgCalendar = 'Kalender';
    $mdDateLocaleProvider.msgOpenCalendar = 'Öppna kalendern';


    // Theming
    // THIS IS NOT BEING USED BECAUSE IT IS MAKING IE11 EXTREMELY SLOW.
    // As of now (2016-07-11), we're only using it for changing the navbar's colors,
    // so it's not that much of a hassle to replace anyway
    // see:
    // https://github.com/angular/material/commit/ea62bc2de4dc09e0d7095b6f96d0746d20baa14a
    //
    // _.each(categoryThemes, function (value, key) {
    //   $mdThemingProvider.definePalette(key, value);
    //   $mdThemingProvider.theme(key)
    //     .primaryPalette(key);
    // });
    //
    //
    //Set theme
    $mdThemingProvider.theme('default')
      .primaryPalette('grey', {
        'default': '900'
      })
      .accentPalette('blue');
  }

  // var categoryThemes = {
  //   'fa7f24': {
  //     '50': '#fdc8a1',
  //     '100': '#fcb988',
  //     '200': '#fcab6f',
  //     '300': '#fb9c56',
  //     '400': '#fb8e3d',
  //     '500': '#FA7F24',
  //     '600': '#f9700b',
  //     '700': '#e66505',
  //     '800': '#cd5a05',
  //     '900': '#b44f04',
  //     'A100': '#fdd6ba',
  //     'A200': '#fee5d2',
  //     'A400': '#fff4eb',
  //     'A700': '#9b4404'
  //   },
  //   '9c0058': {
  //     '50': '#ff1c9c',
  //     '100': '#ff0391',
  //     '200': '#e80083',
  //     '300': '#cf0075',
  //     '400': '#b50066',
  //     '500': '#9C0058',
  //     '600': '#82004a',
  //     '700': '#69003b',
  //     '800': '#4f002d',
  //     '900': '#36001e',
  //     'A100': '#ff36a7',
  //     'A200': '#ff4fb2',
  //     'A400': '#ff69be',
  //     'A700': '#1c0010'
  //   },
  //   'f3b115': {
  //     '50': '#f9d98e',
  //     '100': '#f8d176',
  //     '200': '#f7c95e',
  //     '300': '#f5c145',
  //     '400': '#f4b92d',
  //     '500': '#F3B115',
  //     '600': '#e3a30c',
  //     '700': '#cb910a',
  //     '800': '#b28009',
  //     '900': '#9a6f08',
  //     'A100': '#fae2a7',
  //     'A200': '#fceabf',
  //     'A400': '#fdf2d7',
  //     'A700': '#825d07'
  //   },
  //   '0079ad': {
  //     '50': '#2dc0ff',
  //     '100': '#14b8ff',
  //     '200': '#00aff9',
  //     '300': '#009de0',
  //     '400': '#008bc6',
  //     '500': '#0079AD',
  //     '600': '#006793',
  //     '700': '#00557a',
  //     '800': '#004360',
  //     '900': '#003247',
  //     'A100': '#47c8ff',
  //     'A200': '#60cfff',
  //     'A400': '#7ad7ff',
  //     'A700': '#00202d'
  //   },
  //   'c7132d': {
  //     '50': '#f1697c',
  //     '100': '#ee5268',
  //     '200': '#ec3a54',
  //     '300': '#ea2340',
  //     '400': '#de1532',
  //     '500': '#C7132D',
  //     '600': '#b01128',
  //     '700': '#980f22',
  //     '800': '#810c1d',
  //     '900': '#6a0a18',
  //     'A100': '#f38091',
  //     'A200': '#f597a5',
  //     'A400': '#f7afb9',
  //     'A700': '#530813'
  //   },
  //   '006e3c': {
  //     '50': '#00ed82',
  //     '100': '#00d474',
  //     '200': '#00ba66',
  //     '300': '#00a158',
  //     '400': '#00874a',
  //     '500': '#006E3C',
  //     '600': '#00542e',
  //     '700': '#003b20',
  //     '800': '#002112',
  //     '900': '#000804',
  //     'A100': '#08ff8f',
  //     'A200': '#21ff9a',
  //     'A400': '#3bffa6',
  //     'A700': '#000000'
  //   },
  //   'c1b20d': {
  //     '50': '#f4e75a',
  //     '100': '#f2e442',
  //     '200': '#f1e02a',
  //     '300': '#efdd12',
  //     '400': '#d9c80f',
  //     '500': '#C1B20D',
  //     '600': '#a99c0b',
  //     '700': '#91860a',
  //     '800': '#797008',
  //     '900': '#615a07',
  //     'A100': '#f5ea72',
  //     'A200': '#f7ee89',
  //     'A400': '#f9f1a1',
  //     'A700': '#4a4405'
  //   },
  //   '62085e': {
  //     '50': '#d812cf',
  //     '100': '#c010b8',
  //     '200': '#a90ea2',
  //     '300': '#910c8b',
  //     '400': '#7a0a75',
  //     '500': '#62085E',
  //     '600': '#4a0647',
  //     '700': '#330431',
  //     '800': '#1b021a',
  //     '900': '#040004',
  //     'A100': '#ec17e3',
  //     'A200': '#ee2fe5',
  //     'A400': '#f046e8',
  //     'A700': '#000000'
  //   },
  //   '006a6d': {
  //     '50': '#00e6ec',
  //     '100': '#00cdd3',
  //     '200': '#00b4b9',
  //     '300': '#009ca0',
  //     '400': '#008386',
  //     '500': '#006A6D',
  //     '600': '#005153',
  //     '700': '#00383a',
  //     '800': '#002020',
  //     '900': '#000707',
  //     'A100': '#07f8ff',
  //     'A200': '#20f9ff',
  //     'A400': '#3afaff',
  //     'A700': '#000000'
  //   },
  //   '928723': {
  //     '50': '#d8cc5c',
  //     '100': '#d3c548',
  //     '200': '#cebf33',
  //     '300': '#bbad2d',
  //     '400': '#a79a28',
  //     '500': '#928723',
  //     '600': '#7d741e',
  //     '700': '#696119',
  //     '800': '#544e14',
  //     '900': '#403b0f',
  //     'A100': '#ddd271',
  //     'A200': '#e2d986',
  //     'A400': '#e7df9a',
  //     'A700': '#2b280a'
  //   },
  //   '8b9a92': {
  //     '50': '#cfd5d2',
  //     '100': '#c2c9c5',
  //     '200': '#b4beb8',
  //     '300': '#a6b2ac',
  //     '400': '#99a69f',
  //     '500': '#8B9A92',
  //     '600': '#7d8e85',
  //     '700': '#718178',
  //     '800': '#65746c',
  //     '900': '#59665f',
  //     'A100': '#dde1df',
  //     'A200': '#eaedec',
  //     'A400': '#f8f9f8',
  //     'A700': '#4d5852'
  //   }
  // }



})();

angular.module("thb").run(["$templateCache", function($templateCache) {$templateCache.put("app/feedback/feedback.html","<div flex ng-cloak><md-content layout-padding layout layout-align=\"center none\" flex><md-card flex flex-gt-xs=70 flex-gt-sm=50 flex-gt-md=40 flex-gt-lg=30><form name=feedback.form ng-submit=\"feedback.form.$valid && feedback.submit($event)\" novalidate><md-card-title flex=initial><md-card-title-text><h1 class=md-title>Lämna feedback</h1></md-card-title-text></md-card-title><md-card-content><p>Tack för att du tar dig tid att lämna feedback. Vi lovar att återkomma till dig så snart vi kan kring det du skriver. Förutom det du skriver till oss nedan kommer även din mail ({{feedback.auth.user.username}}) att skickas med så att vi kan kontakta dig med uppföljande frågor.</p><md-input-container><label>Ämne</label><input required type=text name=topic ng-model=feedback.topic><div ng-messages=feedback.form.topic.$error><div ng-message=required>Du måste ange ett ämne.</div></div></md-input-container><md-input-container class=md-block flex><label>Meddelande</label><textarea ng-model=feedback.message columns=1 rows=5></textarea></md-input-container></md-card-content><md-card-actions layout-align=\"end end\" layout><md-button type=submit class=\"md-primary md-raised\">Skicka</md-button></md-card-actions></form></md-card></md-content></div>");
$templateCache.put("app/account/log/log.html","<div ng-cloak layout layout-align=\"center none\"><div layout=column flex=70><div infinite-scroll=$ctrl.service.next() infinite-scroll-disabled=\"!$ctrl.scrollContainer || $ctrl.service.isBusy || $ctrl.service.noMoreDays\" infinite-scroll-distance=2 infinite-scroll-container=$ctrl.scrollContainer><div ng-repeat=\"day in $ctrl.service.items track by day.date\"><md-card style=\"position: relative\"><md-card-title><md-card-title-text><span class=md-headline>{{day.date | amDateFormat: \'D/M\'}} ({{day.date | amCalendar}}) - {{day.decisions.length}} triagering{{day.decisions.length === 1 ? \'\': \'ar\'}}</span></md-card-title-text></md-card-title><md-card-content><table md-table><tbody md-body><tr md-row ng-repeat=\"decision in day.decisions | limitTo: $ctrl.getDayLimit(day) track by decision.id\"><td md-cell class=log><span>{{decision.date | amDateFormat:\'HH:mm\'}}</span></td><td md-cell class=log><div class=category-indicator-box ng-style=\"{\'background-color\': decision.colour}\"></div></td><td md-cell class=log><span style=\"word-wrap: break-word\">{{decision.mainSymptom}}</span></td><td md-cell class=log><span>{{decision.solution}}</span></td><td md-cell class=log><md-button ng-href=\"/#/symptom/{{decision.symptomId}}?solution={{decision.solutionId}}&id={{decision.id}}&date={{decision.date}}\" class=md-icon-button aria-label=\"go to solution\"><md-icon class=material-icons>arrow_forward</md-icon></md-button></td></tr></tbody></table></md-card-content><div class=expand-button ng-hide=\"day.decisions.length <= $ctrl.DECISION_LIMIT\"><md-button class=\"md-fab md-mini\" ng-click=\"day.expanded = !day.expanded\"><div class=\"bubble md-whiteframe-1dp\" ng-hide=\"day.expanded || $ctrl.getRemainingDecisions(day) < 1\"><span>{{$ctrl.getRemainingDecisions(day)}}</span></div><md-icon class=\"material-icons md-primary\">{{day.expanded ? \'arrow_upward\' : \'arrow_downward\'}}</md-icon></md-button></div><div class=overlay ng-hide=\"day.expanded || day.decisions.length <= $ctrl.DECISION_LIMIT\"></div></md-card><div ng-show=\"$ctrl.isNewMonth( $index) || $ctrl.gapBetweenDays($index)\" layout=column layout-align=\"center center\"><div class=zigzag></div><h1 class=md-title ng-show=$ctrl.isNewMonth($index)>{{ day.date | amDateFormat: \'MMMM YYYY\' }}</h1><span class=md-title ng-hide=$ctrl.isNewMonth($index) ng-show=$ctrl.gapBetweenDays($index)>{{ $ctrl.getElapsedTime($index) }} utan en triagering.</span><div class=zigzag></div></div></div><p ng-if=$ctrl.service.noMoreDays>Det finns inga fler triageringar att visa.</p></div></div></div>");
$templateCache.put("app/account/settings/settings.html","<md-content ng-cloak layout layout-align=\"center none\"><div layout=column flex flex-gt-xs=80 flex-gt-sm=60 flex-gt-md=50 flex-gt-lg=40><form name=$ctrl.userForm ng-submit=\"$ctrl.userForm.$valid && $ctrl.updateUserInfo($event)\" novalidate><md-card><md-card-title flex=initial><md-card-title-text><h1 class=md-title>Kontaktuppgifter</h1></md-card-title-text></md-card-title><md-card-content layout-padding><div layout layout-xs=column><md-input-container class=md-block flex><label>Förnamn</label><input required name=firstName ng-model=$ctrl.user.firstName><div ng-messages=$ctrl.userForm.firstName.$error><div ng-message=required>Du måste ange ditt förnamn.</div></div></md-input-container><md-input-container class=md-block flex><label>Efternamn</label><input required name=lastName ng-model=$ctrl.user.lastName><div ng-messages=$ctrl.userForm.lastName.$error><div ng-message=required>Du måste ange ditt efternamn.</div></div></md-input-container></div><div layout layout-xs=column><md-input-container class=md-block flex><label>E-post</label><input required type=email name=email ng-model=$ctrl.user.username disabled><div ng-messages=$ctrl.userForm.email.$error><div ng-message=required>Du måste ange din e-postadress.</div><div ng-message=email>Du måste ange en giltig e-postadress.</div></div></md-input-container></div><div layout layout-xs=column><md-input-container class=md-block flex><label>Telefonnummer</label><input required type=text name=phone ng-model=$ctrl.user.phone><div ng-messages=$ctrl.userForm.phone.$error><div ng-message=required>Du måste ange ditt telefonnummer.</div></div></md-input-container><md-input-container class=md-block flex><label>Organisation</label><input required type=text name=organisation ng-model=$ctrl.user.organisation><div ng-messages=$ctrl.userForm.organisation.$error><div ng-message=required>Du måste ange din organisation.</div></div></md-input-container></div><div layout layout-xs=column><md-input-container class=md-block flex><label>Enhet</label><input required type=text name=unit ng-model=$ctrl.user.unit><div ng-messages=$ctrl.userForm.unit.$error><div ng-message=required>Du måste ange din enhet.</div></div></md-input-container><md-input-container class=md-block flex><label>Arbetstitel</label><input required type=text name=title ng-model=$ctrl.user.title><div ng-messages=$ctrl.userForm.title.$error><div ng-message=required>Du måste ange din arbetstitel.</div></div></md-input-container></div></md-card-content><md-card-actions layout layout-align=\"end center\"><md-button type=submit class=\"md-primary md-raised\" ng-disabled=!$ctrl.userForm.$valid>Spara</md-button></md-card-actions></md-card></form><form name=$ctrl.passwordForm ng-submit=\"$ctrl.passwordForm.$valid && $ctrl.changePassword($event)\" novalidate><md-card><md-card-title flex=initial><md-card-title-text><h1 class=md-title>Byt lösenord</h1></md-card-title-text></md-card-title><md-card-content layout-padding layout=column><div layout layout-xs=column><md-input-container class=md-block flex><label>Nytt Lösenord</label><input required type=password ng-minlength=5 name=password ng-model=$ctrl.hash><div ng-messages=$ctrl.passwordForm.password.$error><div ng-message=required>Du måste ange ett lösenord.</div><div ng-message=minlength>Lösenordet måste vara längre än 5 tecken.</div></div></md-input-container><md-input-container class=md-block flex><label>Upprepa det nya lösenordet</label><input required type=password ng-minlength=5 name=confirm ng-model=$ctrl.confirm match=$ctrl.hash><div ng-messages=$ctrl.passwordForm.confirm.$error><div ng-message=required>Ange ditt nya lösenord igen.</div><div ng-message=minlength>Lösenordet måste vara längre än 5 tecken.</div><div ng-message=match>Lösenorden stämmer inte överrens.</div></div></md-input-container></div><div layout><md-input-container class=md-block flex><label>Nuvarande lösenord</label><input required validate-password type=password name=currentPassword ng-model=$ctrl.currentPassword><div ng-messages=$ctrl.passwordForm.currentPassword.$error><div ng-message=required>Ange ditt lösenord.</div><div ng-message=valid>Fel lösenord.</div></div></md-input-container></div></md-card-content><md-card-actions layout-align=\"end end\" layout><md-button type=submit class=\"md-primary md-raised\" ng-disabled=!$ctrl.passwordForm.$valid>Spara</md-button></md-card-actions></md-card></form></div></md-content>");
$templateCache.put("app/admin/users/users.html","<md-content ng-cloak layout-align=\"center stretch\"><div layout=column><md-card><md-toolbar class=\"md-table-toolbar md-default\"><div class=md-toolbar-tools><md-autocomplete md-search-text=$ctrl.searchText placeholder=\"Filtrera användare\" md-items=\"item in []\" flex></md-autocomplete><md-input-container><md-select ng-model=$ctrl.type md-on-close=$ctrl.refresh() style=\"padding:0px 8px\" aria-label=kontotyp><md-option ng-value=opt ng-repeat=\"opt in $ctrl.accountTypes\">{{ opt }}</md-option></md-select></md-input-container><div layout layout-align=\"center center\" flex=20><div style=\"padding:0px 8px\"><span>Månader:</span></div><md-slider md-discrete ng-model=$ctrl.months step=1 min=1 max=6 aria-label=months flex></md-slider></div><md-button class=md-icon-button ng-click=$ctrl.deny() ng-show=$ctrl.selected.length><md-icon class=material-icons>thumb_down</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.approve() ng-show=$ctrl.selected.length><md-icon class=material-icons>thumb_up</md-icon></md-button><md-button class=md-icon-button ng-click=$ctrl.refresh()><md-icon class=material-icons>refresh</md-icon></md-button></div></md-toolbar><md-table-container><table md-table md-row-select multiple ng-model=$ctrl.selected md-progress=$ctrl.promise><thead md-head md-order=$ctrl.query.order><tr md-row><th md-column md-order-by=username>Epost</th><th md-column md-order-by=firstName>Förnamn</th><th md-column md-order-by=lastName>Efternamn</th><th md-column md-order-by=phone>Telefon</th><th md-column md-order-by=organisation>Organisation</th><th md-column md-order-by=unit>Enhet</th><th md-column md-order-by=title>Titel</th><th md-column md-order-by=registered>Registrerad</th><th md-column md-order-by=expires>Går ut</th><th md-column md-order-by=accountType>Kontotyp</th><th md-column md-order-by=role>Roll</th></tr></thead><tbody md-body><tr md-row md-select=user md-select-id=id md-auto-select multiple ng-model=$ctrl.selected ng-repeat=\"user in $ctrl.users\n                | filter: ($ctrl.searchText||\'\')\n                | orderBy: $ctrl.query.order\n                | limitTo: $ctrl.query.limit: ($ctrl.query.page - 1) * $ctrl.query.limit\"><td md-cell>{{user.username}}</td><td md-cell ng-click=\"$ctrl.editText($event, user, \'firstName\')\">{{user.firstName}}</td><td md-cell ng-click=\"$ctrl.editText($event, user, \'lastName\')\">{{user.lastName}}</td><td md-cell ng-click=\"$ctrl.editText($event, user, \'phone\')\">{{user.phone}}</td><td md-cell ng-click=\"$ctrl.editText($event, user, \'organisation\')\">{{user.organisation}}</td><td md-cell ng-click=\"$ctrl.editText($event, user, \'unit\')\">{{user.unit}}</td><td md-cell ng-click=\"$ctrl.editText($event, user, \'title\')\">{{user.title}}</td><td md-cell>{{user.registered | date}}</td><td md-cell ng-click=\"$ctrl.editDate($event, user, \'expires\')\">{{user.expires | date}}</td><td md-cell><md-select ng-model=user.accountType placeholder=kontotyp md-on-close=$ctrl.saveUser(user)><md-option ng-value=type ng-repeat=\"type in $ctrl.accountTypes\">{{type}}</md-option></md-select></td><td md-cell><md-select ng-model=user.role placeholder=roll md-on-close=$ctrl.saveUser(user)><md-option ng-value=role ng-repeat=\"role in $ctrl.roles\">{{role}}</md-option></md-select></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=$ctrl.query.limit md-limit-options=\"[20, 50, 100]\" md-page=$ctrl.query.page md-total=\"{{($ctrl.users | filter: ($ctrl.searchText||\'\')).length}}\" md-page-select></md-table-pagination></md-card></div></md-content>");
$templateCache.put("app/components/bottomNav/bottomNav.html","<div layout=row layout-align=\"center start\" class=bottom-nav ng-show=$bot.isStandalone><md-toolbar flex layout=row><div class=md-toolbar-tools><md-button ng-click=$bot.goBack($event) ng-disabled=!$bot.canGoBack() class=md-icon-button aria-label=\"go back\"><md-icon class=material-icons>keyboard_arrow_left</md-icon></md-button><md-button ng-click=$bot.goForward($event) ng-disabled=!$bot.canGoForward() class=md-icon-button aria-label=\"go foward\"><md-icon class=material-icons>keyboard_arrow_right</md-icon></md-button></div></md-toolbar></div>");
$templateCache.put("app/components/breadCrumbs/breadCrumbs.html","<div class=breadcrumbs ng-hide=\"$ctrl.$mdMedia(\'xs\') && $ctrl.isFrontPage()\"><ol class=animate-crumbs ng-style=offset><li ng-repeat=\"crumb in $ctrl.service.breadCrumbs\" class=crumb ng-class=\"{active: $last}\"><a class=md-subhead ng-if=!$last ng-href=#{{$ctrl.prefix}}/{{$ctrl.kebabCase(crumb.type)}}/{{crumb.id}}>{{crumb.name}}</a> <span class=md-subhead ng-if=$last>{{crumb.name}}</span></li></ol></div>");
$templateCache.put("app/components/cookieNotification/cookieNotification.html","<div layout layout-align=\"center center\" ng-if=$ctrl.showCookieNotification flex><div flex flex-gt-xs=80>Tonttu använder cookies för att förbättra din upplevelse på den här sidan. Genom att använda Tonttus triagehandbok så samtycker du till att cookies lagras på din dator.</div><div layout=column layout-gt-xs=row layout-align=\"center center\"><md-button class=md-raised ng-click=$ctrl.allowCookies()>Ok!</md-button><md-button href=#/cookies>Läs mer</md-button></div></div>");
$templateCache.put("app/components/leftMenu/leftMenu.html","<md-content class=\"animate-show md-whiteframe-2dp\" layout=column ng-cloak ng-show=\"list.service.show && !list.isTHB()\"><md-content layout=row flex><!--   <md-sidenav class=\"md-sidenav-left md-whiteframe-z2\" md-is-open=\"list.service.show\" md-is-locked-open=\"list.service.show\" layout=\"column\"> --><md-content layout=column layout-align=space-between flex><md-list class=left-menu ng-show=\"list.service.type === \'categories\'\"><md-list-item class=\"md-whiteframe-1dp md-margin\" ng-repeat=\"item in list.service.items\" ng-click=\"list.navigate($event, item.id)\" ng-style=\"{\'background-color\': item.colour}\" aria-label={{item.name}}><p class=link>{{item.name}}</p></md-list-item></md-list><md-list class=left-menu ng-show=\"list.service.type === \'manual\'\"><div ng-repeat=\"group in list.service.items\"><h3 class=\"manual-title md-margin\" ng-class=\"{first: $first}\">{{group.heading}}</h3><thb-list-item ng-repeat=\"item in group.manualItems\" click=\"list.navigate($event, item.id)\" aria-label={{item.name}}>{{item.name}}</thb-list-item></div></md-list><div layout layout-align=\"center center\" style=\"flex: none !important\"><div layout layout-align=\"space-around center\" flex=60><div flex=40 class=logo><img src=/assets/images/tonttu-logga-alpha-mellan.png></div><div flex=20 class=logo ng-if=list.isSkane><img src=/assets/images/rs_webb_trans.png></div></div></div></md-content></md-content></md-content>");
$templateCache.put("app/components/mainMenu/mainMenu.html","<md-sidenav class=\"md-sidenav-left main-menu\" md-component-id=main-menu md-is-open=mm.isOpen layout=column flex><md-toolbar class=\"md-tall user-toolbar\" layout=column ng-if=mm.auth.isAuthenticated()><span flex></span><div class=user-info layout=column><span>{{mm.auth.user.firstName}} {{mm.auth.user.lastName}} </span><span>{{mm.user.username}}</span></div></md-toolbar><md-content layout-padding layout=column flex><!-- MOBILE LIST --><md-list hide-gt-xs><md-list-item ng-repeat=\"item in mm.mobileItems\" ng-click=mm.navigateTo(item.url) ng-hide=\"item.authenticated && !mm.auth.isAuthenticated()\"><md-icon class=md-icon-font>{{item.icon}}</md-icon><p>{{item.title}}</p></md-list-item></md-list><!-- SHOWN TO ALL USERS --><md-list ng-show=\"mm.auth.hasRole(\'reader\')\"><!-- HIDE ON MOBILE --><md-list-item ng-repeat=\"item in mm.readerItems\" ng-click=mm.navigateTo(item.url) hide-xs><md-icon class=md-icon-font>{{item.icon}}</md-icon><p>{{item.title}}</p></md-list-item><!-- --><md-list-item ng-show=\"mm.auth.hasRole(\'editor\') || mm.auth.hasRole(\'admin\')\" ng-repeat=\"item in mm.editorItems\" ng-click=mm.navigateTo(item.url)><md-icon class=md-icon-font>{{item.icon}}</md-icon><p>{{item.title}}</p></md-list-item><!-- --><md-divider></md-divider><md-list-item ng-show=\"mm.auth.hasRole(\'admin\')\" ng-repeat=\"item in mm.adminItems\" ng-click=mm.navigateTo(item.url)><md-icon class=md-icon-font>{{item.icon}}</md-icon><p>{{item.title}}</p></md-list-item><div ng-show=mm.isAuthenticated()><md-divider></md-divider><md-list-item ng-repeat=\"item in mm.generalItems\" ng-click=mm.navigateTo(item.url)><md-icon class=md-icon-font>{{item.icon}}</md-icon><p>{{item.title}}</p></md-list-item></div></md-list><div flex></div><md-list><md-list-item ng-click=mm.logout() ng-if=mm.auth.isAuthenticated()><md-icon class=md-icon-font>exit_to_app</md-icon><p>Logga ut</p></md-list-item><md-list-item ng-click=\"mm.navigateTo(\'/login\')\" ng-if=!mm.auth.isAuthenticated() hide-gt-xs><md-icon class=md-icon-font>exit_to_app</md-icon><p>Logga in</p></md-list-item></md-list></md-content></md-sidenav>");
$templateCache.put("app/components/navbar/copyTextDialog.tmpl.html","<md-dialog aria-label=\"Kopiera plats\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>Kopiera plats</h2><span flex></span><md-button class=md-icon-button aria-label=Stäng ng-click=copy.closeDialog()><md-icon class=material-icons>close</md-icon></md-button></div></md-toolbar><md-dialog-content flex=auto layout layout-padding><div class=md-dialog-content layout=column><p>Markera texten och tryck CTRL-C (eller CMD-C på Mac).</p><md-input-container flex><input ng-model=copy.location aria-label=\"Kopiera denna plats\" ng-keyup=copy.up($event) ng-keydown=copy.down($event) type=text md-select-on-focus md-autofocus></md-input-container></div></md-dialog-content><md-dialog-actions><md-button ng-click=copy.closeDialog() class=md-primary>Stäng</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar class=animate-color ng-style=\"{\'background-color\': \'#\' + nav.service.theme}\"><div class=md-toolbar-tools><md-button ng-if=\"nav.auth.isAuthenticated() || nav.$mdMedia(\'xs\')\" class=md-icon-button aria-label=Menu ng-click=nav.openMainMenu()><md-tooltip class=navbar-tooltip ng-if=\"!nav.$mdMedia(\'xs\')\">Meny</md-tooltip><md-icon class=material-icons>menu</md-icon></md-button><h1 flex-xs ng-hide=\"nav.$mdMedia(\'xs\') && !nav.isFrontPage()\"><a href=/#/ ng-click=nav.closeMainMenu()>Triagehandboken</a></h1><bread-crumbs flex></bread-crumbs><div ng-show=nav.auth.isAuthenticated() layout><md-button ng-show=nav.navBarService.showSearch class=md-icon-button aria-label=Search ng-click=nav.openSearch()><md-tooltip class=navbar-tooltip>Sök</md-tooltip><md-icon class=material-icons>search</md-icon></md-button></div><div ng-hide=nav.auth.isAuthenticated() hide-xs><md-button href=#/register class=md-no-focus>Ny användare</md-button><md-button href=#/login class=\"md-hue-1 md-raised md-no-focus\">Logga in</md-button></div></div></md-toolbar>");
$templateCache.put("app/components/search/search.html","<md-sidenav class=md-sidenav-right md-component-id=search layout=column><md-toolbar layout layout-align=\"center center\" class=animate-color ng-style=\"{\'background-color\': \'#\' + nav.service.theme}\"><div class=md-toolbar-tools><md-autocomplete md-input-id=search-input md-autofocus name=search placeholder=Sök md-selected-item=s.selectedItem md-search-text=s.query md-search-text-change=s.tryClear(s.query) md-items=\"item in s.search(s.query)\" md-no-cache=true md-delay=500 md-min-length=3 flex=90></md-autocomplete><md-button class=md-icon-button aria-label=close ng-click=s.close()><md-icon class=md-icon-font>close</md-icon></md-button></div></md-toolbar><md-content><div ng-show=s.noResult layout-padding><p>Inga resultat matchade din sökning</p></div><thb-list-item ng-repeat=\"item in s.results\" click=\"s.navigate(item.type, item.id);\" border-colour=item.colour class=search-card><span class=md-caption ng-bind-html=item.navigation></span><h1 class=md-title ng-show=item.name ng-bind-html=item.name></h1><h1 class=md-title ng-show=item.obsTitle>{{item.obsTitle}}</h1><div ng-show=item.obs ng-bind-html=s.parser.parse(item.obs)></div><div ng-show=\"item.icd || item.ksh\"><div ng-show=item.icd layout=column><p><b>Förslag på ICD-koder</b></p><ul class=code-list><li ng-repeat=\"code in item.icd\" layout><span class=\"md-body-2 code-code\">{{code.code}}:</span> <span ng-bind-html=code.codeText style=\"display: inline-block\"></span></li></ul></div><div ng-show=item.ksh97 layout=column><p><b>Förslag på KSH97-koder</b></p><ul class=code-list><li ng-repeat=\"code in item.ksh97\" layout><span class=\"md-body-2 code-code\">{{code.code}}:</span> <span ng-bind-html=code.codeText style=\"display: inline-block\"></span></li></ul></div></div></thb-list-item></md-content></md-sidenav>");
$templateCache.put("app/components/thbListItem/thbListItem.html","<md-card class=thb-list-item ng-style=\"{\'border-color\': $ctrl.borderColour}\"><a ng-href={{$ctrl.url}} ng-click=$ctrl.click() md-ink-ripple=true><md-card-content layout=column><ng-transclude></ng-transclude></md-card-content></a></md-card>");
$templateCache.put("app/public/cookies/cookies.html","<md-content ng-cloak layout layout-align=\"center none\"><div layout=column flex flex-gt-xs=80 flex-gt-sm=60 flex-gt-md=50 flex-gt-lg=40><md-card><md-card-title flex=initial><md-card-title-text><h1 class=md-title>Om cookies</h1></md-card-title-text></md-card-title><md-card-content layout-padding><p>En cookie (eller kaka) är en liten textfil som en webbplats begär att få spara på besökarens dator. Cookies används på många webbplatser för att ge en besökare tillgång till olika funktioner.</p><p>Enligt lagen om elektronisk kommunikation ska alla som besöker en webbplats med cookies få tillgång till information om att webbplatsen innehåller cookies och ändamålet med användningen av dem.</p><h1 class=md-title>Vilka cookies används på triagehandboken.se?</h1><p>Nedan följer en lista på cookies som används på denna webbplats, och vad de används till.</p><table class=cookies><tr><th>Namn</th><th>Beskrivning</th></tr><tr><td>allow_cookies</td><td>Används för att bestämma om cookie-notifieringen ska visas eller inte.</td></tr><tr><td>_ga</td><td>Används vid insamling av statistik för att skilja mellan användare.</td></tr><tr><td>_gid</td><td>Används vid insamling av statistik för att skilja mellan användare.</td></tr><tr><td>_gat</td><td>Används vid insamling av statistik för att begränsa antal anrop.</td></tr></table></md-card-content></md-card></div></md-content>");
$templateCache.put("app/public/login/login.html","<div flex ng-cloak><form name=form ng-submit=\"form.$valid && vm.login($event)\" novalidate><md-content layout-padding layout layout-align=\"center stretch\" flex><md-card flex flex-gt-xs=70 flex-gt-sm=50 flex-gt-md=40 flex-gt-lg=30><md-card-title flex=initial><h1 class=md-title>Logga in</h1></md-card-title><md-card-content layout=row layout-padding><div layout=column flex layout-padding><md-input-container class=md-block flex=initial><label>E-post</label><input required name=email ng-model=vm.email><div ng-messages=form.email.$error><div ng-message=required>Ange din e-postadress eller användarnamn.</div><!--<div ng-message=\"email\">Du måste ange en giltig e-postadress.</div>--></div></md-input-container><md-input-container class=md-block flex=initial><label>Lösenord</label><input required type=password name=password ng-model=vm.password><div ng-messages=form.email.$error><div ng-message=required>Ange ditt lösenord</div><div ng-message=email>Du måste ange en giltig e-postadress.</div></div></md-input-container><div ng-show=vm.incorrect class=red>Felaktigt e-postadress eller lösenord.</div><div ng-show=vm.pendingAccount class=red>Detta konto har inte blivit aktiverat ännu. Du kommer att få ett epost-meddelande när detta skett.</div><div ng-show=vm.inactiveAccount class=red>Detta konto är inte längre aktivt. Om du vill aktivera ditt konto, var vänlig <a href=mailto:info@tonttu.se>kontakta oss</a>.</div><div ng-show=vm.otherError class=red>Ett fel har inträffat. Försök igen senare.</div></div></md-card-content><md-card-actions layout layout-xs=column><md-button href=/#/register flex-order-xs=3>Ny användare</md-button><span flex></span><md-button href=/#/forgot-password flex-order-xs=2>Glömt lösenord</md-button><md-button type=submit class=\"md-primary md-raised\" flex-order-xs=1>Logga in</md-button></md-card-actions></md-card></md-content></form></div>");
$templateCache.put("app/public/register/register.html","<div flex ng-cloak><md-content layout-padding layout layout-align=\"center stretch\" flex><md-card flex flex-gt-xs=80 flex-gt-sm=60 flex-gt-md=50 flex-gt-lg=40><md-card-title flex=initial><md-card-title-text><h1 class=md-title>Anmäl intresse för ett konto till Tonttu Triagehandboken</h1><p>Observera att det kan ta ett par timmar, upp till en dag, innan din anmälan är hanterad.</p></md-card-title-text></md-card-title><md-card-content><form name=form ng-submit=\"form.$valid && register.submit($event)\" novalidate><div layout flex layout-xs=column><md-input-container class=md-block flex><label>Förnamn</label><input required name=firstName ng-model=register.user.firstName><div ng-messages=form.firstName.$error><div ng-message=required>Du måste ange ditt förnamn.</div></div></md-input-container><md-input-container class=md-block flex><label>Efternamn</label><input required name=lastName ng-model=register.user.lastName><div ng-messages=form.lastName.$error><div ng-message=required>Du måste ange ditt efternamn.</div></div></md-input-container></div><div layout flex layout-xs=column><md-input-container class=md-block flex><label>Telefonnummer</label><input required type=text name=phone ng-model=register.user.phone><div ng-messages=form.phone.$error><div ng-message=required>Du måste ange ditt telefonnummer.</div></div></md-input-container><md-input-container class=md-block flex><label>Organisation</label><input required type=text name=organisation ng-model=register.user.organisation><div ng-messages=form.organisation.$error><div ng-message=required>Du måste ange din organisation.</div></div></md-input-container></div><div layout flex layout-xs=column><md-input-container class=md-block flex><label>Enhet</label><input required type=text name=unit ng-model=register.user.unit><div ng-messages=form.unit.$error><div ng-message=required>Du måste ange din enhet.</div></div></md-input-container><md-input-container class=md-block flex><label>Arbetstitel</label><input required type=text name=title ng-model=register.user.title><div ng-messages=form.title.$error><div ng-message=required>Du måste ange din arbetstitel</div></div></md-input-container></div><div layout flex layout-xs=column><md-input-container class=md-block flex><md-checkbox aria-label=\"Checkbox student\" ng-model=register.isStudent>Är du student?</md-checkbox></md-input-container><div layout ng-show=register.isStudent flex><p flex>Vi kommer att kontakta dig för att bekräfta din studentstatus och ditt examensdatum.</p></div></div><div layout flex layout-xs=column><md-input-container class=md-block flex><label>Epost</label><input required type=email name=username ng-model=register.user.username><div ng-messages=form.username.$error><div ng-message=required>Du måste ange din e-postadress.</div><div ng-message=email>Du måste ange en giltig e-postadress.</div></div></md-input-container><md-input-container class=md-block flex><label>Upprepa Epost</label><input required type=email name=confirmEmail ng-model=register.user.confirmEmail match=register.user.username><div ng-messages=form.confirmEmail.$error><div ng-message=required>Du måste ange din e-postadress.</div><div ng-message=email>Du måste ange en giltig e-postadress.</div><div ng-message=match>Mailadresserna stämmer inte överrens.</div></div></md-input-container></div><div layout flex layout-xs=column><md-input-container class=md-block flex><label>Lösenord</label><input required type=password ng-minlength=5 name=password ng-model=register.user.hash><div ng-messages=form.password.$error><div ng-message=required>Du måste ange ett lösenord.</div><div ng-message=minlength>Lösenordet måste vara längre än 5 tecken.</div></div></md-input-container><md-input-container class=md-block flex><label>Upprepa lösenord</label><input required type=password ng-minlength=5 name=confirmPassword ng-model=register.user.confirmPassword match=register.user.hash><div ng-messages=form.confirmPassword.$error><div ng-message=required>Ange ditt lösenord igen.</div><div ng-message=minlength>Lösenordet måste vara längre än 5 tecken.</div><div ng-message=match>Lösenorden stämmer inte överrens.</div></div></md-input-container></div><div layout layout-align=\"end center\" flex><md-button type=submit class=\"md-primary md-raised\" ng-disabled=\"!form.$valid || register.submitted\">Skicka</md-button></div></form></md-card-content></md-card></md-content></div>");
$templateCache.put("app/thb/category/category.html","<div layout-padding-gt-md ng-cloak><div layout=column flex flex-gt-md=80 flex-gt-lg=70><div ng-show=$ctrl.obs><h1 class=md-title>Om kapitlet {{$ctrl.name}}</h1><div class=md-margin><span ng-bind-html=$ctrl.obs></span></div></div><md-list><h1 ng-show=$ctrl.subcategories class=md-title>Underkategorier</h1><h1 ng-show=$ctrl.mainSymptoms class=md-title>Huvudsymtom</h1><thb-list-item ng-repeat=\"link in $ctrl.subcategories\" url=\"\'#\' + $ctrl.prefix + \'/subcategory/\' + link.id\">{{link.name}}</thb-list-item><thb-list-item ng-repeat=\"link in $ctrl.mainSymptoms\" url=\"\'#\' + $ctrl.prefix + \'/main-symptom/\' + link.id\">{{link.name}}</thb-list-item></md-list></div></div>");
$templateCache.put("app/thb/mainSymptom/mainSymptom.html","<div layout-padding-gt-md ng-cloak><div layout=column flex flex-gt-md=80 flex-gt-lg=70><div ng-show=$ctrl.obs><h1 class=md-title>Observera</h1><div class=md-margin><span ng-bind-html=$ctrl.obs></span></div></div><div ng-show=$ctrl.symptoms.length><md-list><h1 class=md-title>Symtom</h1><thb-list-item ng-repeat=\"item in $ctrl.symptoms\" url=\"\'#\' + $ctrl.prefix + \'/symptom/\' + item.id\">{{item.name}}</thb-list-item></md-list></div></div></div>");
$templateCache.put("app/thb/manual/manual.html","<div ng-hide=$ctrl.pdf ng-cloak><div layout=column flex flex-gt-md=80 flex-gt-lg=70><md-card><md-card-title flex=initial><md-card-title-text><span class=md-title>{{$ctrl.name}}</span></md-card-title-text></md-card-title><md-card-content><div ng-bind-html=$ctrl.obs></div></md-card-content></md-card></div></div><div ng-show=$ctrl.pdf ng-cloak layout-fill><div layout=column layout-fill><md-card layout=row flex><div layout=column flex><md-card-content layout=column flex><h2 class=md-title>{{$ctrl.name}}</h2><p>Klicka <a href={{$ctrl.pdfUrl}} target=_blank hide-gt-xs>här</a> för att öppna dokumentet i en ny flik.</p><object ng-if=$ctrl.IE11 data=https://tonttu.se/db/resources/tetanus.pdf type=application/pdf flex></object><object ng-if=\"!$ctrl.IE11 && !$ctrl.$mdMedia(\'xs\')\" data={{$ctrl.pdf}} type=application/pdf flex></object></md-card-content></div></md-card></div></div>");
$templateCache.put("app/thb/news/news.html","<div layout-padding-gt-md ng-cloak ng-hide=$ctrl.shouldHide()><div layout=column flex flex-gt-md=80 flex-gt-lg=70><md-card ng-repeat=\"newsItem in $ctrl.news\"><md-card-title flex=initial><md-card-title-text><span class=md-title>{{newsItem.headline}}<span class=md-subhead> - {{newsItem.timestamp | date}}</span></span></md-card-title-text></md-card-title><md-card-content><p ng-bind-html=$ctrl.$sce.trustAsHtml(newsItem.content)></p></md-card-content></md-card></div></div>");
$templateCache.put("app/thb/subCategory/subCategory.html","<div layout-padding-gt-md ng-cloak><div layout=column flex flex-gt-md=80 flex-gt-lg=70><div ng-show=$ctrl.obs><h1 class=md-title>Observera</h1><div class=md-margin><span ng-bind-html=$ctrl.obs></span></div></div><md-list><h1 class=md-title>Huvudsymtom</h1><thb-list-item ng-repeat=\"item in $ctrl.mainSymptoms\" url=\"\'#\' + $ctrl.prefix + \'/main-symptom/\' + item.id\">{{item.name}}</thb-list-item></md-list></div></div>");
$templateCache.put("app/thb/symptom/symptom.html","<div layout-padding-gt-md ng-cloak><div layout=column flex flex-gt-md=80 flex-gt-lg=70><h1 class=md-title ng-show=$ctrl.solutions.length>Vårdnivå och symtombeskrivning</h1><md-card selectable-text ng-repeat=\"solution in $ctrl.solutions\" class=\"md-primary solution fade\" ng-style=\"{\'background-color\': $ctrl.colour}\" ng-class=\"{last: $last, \'not-selected\': $ctrl.selectedSolution && !$ctrl.isSelected(solution), selected: $ctrl.isSelected(solution)}\" ng-click=$ctrl.cardClicked(solution) id=solution-{{solution.id}}><div class=container layout><div layout=column flex><md-card-title flex=initial><md-card-title-text><span class=md-title>{{solution.name}}</span></md-card-title-text></md-card-title><md-card-content layout><p ng-bind-html=$ctrl.$sce.trustAsHtml(solution.obs) flex></p></md-card-content></div><div layout=column layout-align=\"center center\"><md-button ng-show=\"!$ctrl.selectedSolution || $ctrl.isSelected(solution)\" class=\"md-fab md-mini\" ng-style=\"{\'background-color\': $ctrl.colour}\" aria-label=\"Välj vårdnivå\" ng-click=$ctrl.solutionClicked(solution)><md-tooltip><span ng-if=$ctrl.isSelected(solution)>Visa alternativ</span> <span ng-if=!$ctrl.selectedSolution>Välj vårdnivå</span></md-tooltip><md-icon class=md-icon-font ng-show=!$ctrl.isSelected(solution)>done</md-icon><!--<md-icon class=\"md-icon-font\" ng-if=\"$ctrl.isSelected(solution)\">check_circle</md-icon>--> <span class=md-title style=\"vertical-align: middle\" ng-show=$ctrl.isSelected(solution)>&bull;&bull;&bull;</span></md-button><div style=width:55px></div></div></div></md-card><div ng-show=$ctrl.obs><h1 class=md-title>Observera</h1><div class=md-margin><span ng-bind-html=$ctrl.obs></span></div></div><div layout=column flex=auto layout-gt-sm flex-gt-sm ng-show=\"$ctrl.icd.length || $ctrl.ksh97.length\" class=codes-container><codes flex=auto flex-gt-sm ng-repeat=\"codeType in $ctrl.codeTypes\" codes=codeType.codes name=codeType.name></codes></div></div></div>");
$templateCache.put("app/public/password/forgot/forgot.html","<div flex ng-cloak><md-content layout-padding-gt-sm layout layout-align=\"center stretch\" flex><md-card flex flex-gt-xs=70 flex-gt-sm=50 flex-gt-md=40 flex-gt-lg=30><md-card-content layout-padding layout=column><h1 class=md-title>Glömt lösenord</h1><p>Om du glömt bort ditt lösenord kan du få det återställt. Skriv in den e-postadress du använde när du registerade dig, så skickar vi en länk där du kan välja ett nytt lösenord. Om du inte fått något e-postmeddelande inom 15 minuter får du gärna <a href=mailto:info@tonttu.se>kontakta oss</a>.</p><form name=form ng-submit=\"form.$valid && fp.submit($event)\" novalidate><div layout flex><md-input-container class=md-block flex><label>E-post</label><input required name=email ng-model=fp.username><div ng-messages=form.email.$error><div ng-message=required>Ange din e-postadress.</div><!--<div ng-message=\"email\">Du måste ange en giltig e-postadress.</div>--></div></md-input-container><div style=margin-top:8px><md-button type=submit class=\"md-primary md-raised\" ng-disabled=\"!form.$valid || fp.submitted\">Skicka</md-button></div></div></form></md-card-content></md-card></md-content></div>");
$templateCache.put("app/public/password/reset/reset.html","<div flex ng-cloak><md-content layout-padding layout layout-align=\"center stretch\" flex><md-card flex flex-gt-xs=70 flex-gt-sm=50 flex-gt-md=40 flex-gt-lg=30><form name=form ng-submit=\"form.$valid && rp.submit($event)\" novalidate><md-card-content layout-padding layout=column><h1 class=md-title>Återställ lösenord</h1><p ng-show=rp.hasData>Ange ett nytt lösenord nedan.</p><p ng-hide=rp.hasData class=red>Hej! Det verkar som att du tagit dig hit på ett sätt som inte vi förväntade oss. Om du tog dig hit genom att kopiera länken i e-postmeddelandet, ber vi dig dubbelkolla att du inte missade några tecken. Om <strong>inte</strong>, så skicka gärna ett mail till <a href=info@tonttu.se>oss</a> så hjälper vi dig.</p><div layout layout-xs=column><md-input-container class=md-block flex><label>Lösenord</label><input required type=password ng-minlength=5 name=password ng-model=rp.hash ng-disabled=!rp.hasData><div ng-messages=form.password.$error><div ng-message=required>Du måste ange ett lösenord.</div><div ng-message=minlength>Lösenordet måste vara längre än 5 tecken.</div></div></md-input-container><md-input-container class=md-block flex><label>Upprepa lösenord</label><input required type=password ng-minlength=5 name=confirm ng-model=rp.confirm match=rp.hash ng-disabled=!rp.hasData><div ng-messages=form.confirm.$error><div ng-message=required>Ange ditt lösenord igen.</div><div ng-message=minlength>Lösenordet måste vara längre än 5 tecken.</div><div ng-message=match>Lösenorden stämmer inte överrens</div></div></md-input-container></div></md-card-content><md-card-actions layout-align=\"end end\" layout><md-button type=submit class=\"md-primary md-raised\" ng-disabled=\"!rp.hasData || !form.$valid || rp.submitted\">Skicka</md-button></md-card-actions></form></md-card></md-content></div>");
$templateCache.put("app/thb/symptom/codes/codes.html","<div flex=auto layout><md-card flex=auto><md-card-title flex=initial><md-card-title-text><span class=md-title>{{$ctrl.name}}-koder</span></md-card-title-text></md-card-title><md-card-content><ul class=code-list><li ng-repeat=\"code in $ctrl.codes\" layout><span class=\"md-body-2 code-code\">{{code.code}} </span><span style=\"display: inline-block\">{{code.codeText}}</span></li></ul></md-card-content></md-card></div>");
$templateCache.put("app/thb/symptom/triageCompleted/triageCompleted.html","<div class=verification-panel><!--<div layout flex layout-align=\"strech start\">--><!--<div class=\"md-title\" flex>--><!--Triagering klar!--><!--</div>--><!--<md-icon click=\"$ctrl.close()\">close</md-icon>--><!--</div>--><!-- <md-button style=\"background-color: #fafafa;\" ng-style=\"{\'color\': $ctrl.color}\" ng-click=\"$ctrl.hide(\'ok\')\" aria-label=\"undo\">Ångra</md-button> --><div class=menu-item ng-disabled=!$ctrl.selectedSolution.undoable ng-click=\"$ctrl.selectedSolution.undoable && $ctrl.undo()\"><md-tooltip ng-if=!$ctrl.selectedSolution.undoable>Beslut äldre än en vecka går inte att ångra</md-tooltip><md-icon class=material-icons>undo</md-icon><div flex>Ångra triagering</div></div><div class=menu-item ng-click=$ctrl.copy()><md-icon class=material-icons>content_copy</md-icon><div flex>Kopiera sökväg</div></div><div class=menu-item ng-click=$ctrl.history()><md-icon class=material-icons>history</md-icon><div flex>Gå till Triagehistorik</div></div></div>");}]);